import React, { useEffect, useState, useCallback, useRef } from 'react';
import AllLeavesCalendar from '../AllLeavesCalendar';
import AllLeavesCalendarMobile from '../AllLeavesCalendarMobile';
import ChatsListModalMobile from '../ChatsListModalMobile';
import ChatAreaMobile from '../Chat/ChatAreaMobile';
import CreateChatModalMobile from '../CreateChatModalMobile';
import LeaveCalendarModal from '../LeaveCalendarModal';
import LeavesMobile from '../LeavesMobile';
import TasksMobile from '../TasksMobile';
import TodoMobile from '../TodoMobile';
import NewsMobile from '../NewsMobile';
import EmployeesMobile from '../EmployeesMobile';
import CongratulationsMobile from '../CongratulationsMobile';
import RatingMobile from '../RatingMobile';
import WorkTimeMobile from '../WorkTimeMobile';
import LeavesWorktimeMobile from '../LeavesWorktimeMobile';
import AdminMobile from '../AdminMobile';
import AdminDesktop from '../AdminDesktop';
import { FaCalendarAlt, FaTasks, FaNewspaper, FaComments, FaUserCircle, FaBars } from 'react-icons/fa';
import { FiSettings, FiAlertTriangle, FiSmile, FiFileText, FiX, FiCode, FiBarChart2, FiPackage, FiUserPlus, FiLayout, FiMoon, FiSun } from 'react-icons/fi';
import { useApp } from '../../context/AppContext';
import { useNdTheme } from '../../utils/ndTheme';
import '../../styles/newDesign.css';
import ReactDOM from 'react-dom';
import SidebarUploadButton from '../Sidebar/SidebarUploadButton';
import UploadModal from '../UploadModal';
import UploadModalMobile from '../UploadModalMobile';
import NewsModal from '../NewsModal';
import WelcomeScreenHero, { welcomeScreenFillStyle, WelcomeScreenPhotoBackground } from '../WelcomeScreenHero';
import TasksModal from '../TasksModal';
import WorkTimeReportModal from '../Modals/WorkTimeReportModal';
import LeavesWorktimeModal from '../LeavesWorktimeModal';
import CongratulationsModal from '../Congratulations/CongratulationsModal';
import EmployeesListModal from '../Modals/EmployeesListModal';
import { getMessengerNestedModalRoot } from '../../utils/nestedModalRoot';
import EmojiSettingsModal from '../Modals/EmojiSettingsModal';
import EmojiSettingsMobile from '../EmojiSettingsMobile';
import TemplatesManagementModal from '../Modals/TemplatesManagementModal';
import TemplatesManagementMobile from '../TemplatesManagementMobile';
import TodoModal from '../Modals/TodoModal';
import KanbanModal from '../Modals/KanbanModal';
import EmployeeRatingModal from '../Rating/EmployeeRatingModal';
import AppTitleSettingsModal from '../Modals/AppTitleSettingsModal';
import FrontendSettingsModal from '../Modals/FrontendSettingsModal';
import PendingRegistrationsModal from '../Modals/PendingRegistrationsModal';
import { isAdminOrHrRole, isDepartmentHeadRole, isHrOrDirectorRole } from '../../utils/adminRoles';
import {
  ORG_DEPARTMENTS,
  JOB_TITLES,
  userMatchesVisibilityList,
  collectUserVisibilityLabels,
  buildAccessDepartmentOptions,
  isOrgDepartment,
  nextDepartmentAfterAccessChange,
  formatUserOrgLines,
  resolvePrimaryOrgDepartment,
  effectiveOrgAccessList,
  accessListIncludes,
} from '../../utils/orgStructure';
import OnecMassShutdownScheduleModal from '../Modals/OnecMassShutdownScheduleModal';
import {
  resolveAppTitleSettingsForMobileWelcome,
  mergeAppTitleSettingsFromStorage,
  unionWelcomeGoogleFontFamiliesInSettings,
} from '../../utils/welcomeScreenSettings';
// ВПР — отдельный функционал только для бухгалтерии/логистики. Не связан с отчётами HR (удалёнка, локальные ПК, мониторинг времени, отработка отгулов).
import VprModal from '../Modals/VprModal';
import WarehouseOrdersModal from '../Modals/WarehouseOrdersModal';

// Заглушка модалки «Заказы склада» больше не используется — подключаем полный WarehouseOrdersModal
const navs = [
  { key: 'welcome', label: 'Экран приветствия', icon: <FiSmile />, emoji: '🖥', color: '#a78bfa', event: 'show-welcome', tip: 'Приветственный экран (оформление и текст)' },
  { key: 'news', label: 'Новости', icon: <FaNewspaper />, emoji: '📰', color: '#fcb69f', event: 'show-news', tip: 'Новостная лента' },
  { key: 'employees', label: 'Сотрудники', icon: <FaUserCircle />, emoji: '👥', color: '#b2ffb2', event: 'show-employees', tip: 'Список сотрудников компании' },
  { key: 'chats', label: 'Чаты', icon: <FaComments />, emoji: '💬', color: '#43e97b', event: 'show-chats', tip: 'Вернуться к чатам' },
  { key: 'todo', label: 'Список дел', icon: <FiFileText />, emoji: '📝', color: '#9b59b6', event: 'show-todo', tip: 'Персональный список дел' },
  { key: 'tasks', label: 'Задачи', icon: <FaTasks />, emoji: '✅', color: '#2193b0', event: 'show-tasks', tip: 'Ваши задачи' },
  { key: 'kanban', label: 'Канбан', icon: <FiLayout />, emoji: '📋', color: '#38bdf8', event: 'show-kanban', tip: 'Канбан задач финансового отдела' },
  { key: 'vpr', label: 'ВПР', icon: <FiBarChart2 />, emoji: '📊', color: '#e67e22', event: 'show-vpr', tip: 'Работа с ВПР для бухгалтерии и логистики' },
  { key: 'orders', label: 'Заказы', icon: <FiPackage />, emoji: '📦', color: '#16a085', event: 'show-orders', tip: 'Заказы склада: сбор и отправка' },
  { key: 'all-leaves', label: 'Общий календарь', icon: <FaUserCircle />, emoji: '📅', color: '#b2bec3', event: 'show-all-leaves', tip: 'Календарь всех сотрудников' },
  { key: 'leaves', label: 'Отгулы', icon: <FaCalendarAlt />, emoji: '🌴', color: '#6dd5ed', event: 'show-leaves', tip: 'Календарь отгулов' },
  { key: 'leaves-worktime', label: 'Отработка отгулов', icon: <FaCalendarAlt />, emoji: '🔄', color: '#b2ffb2', event: 'show-leaves-worktime', tip: 'Отчет по отработке отгулов' },
  { key: 'worktime', label: 'Мониторинг времени', icon: <FaCalendarAlt />, emoji: '⏱', color: '#ffe082', event: 'show-worktime', tip: 'Отчет по рабочему времени' },
  { key: 'admin', label: 'Управление', icon: <FiSettings />, emoji: '⚙️', color: '#a3e635', event: 'show-admin', tip: 'Администрирование' },
];

const NAV_BY_KEY = Object.fromEntries(navs.map((n) => [n.key, n]));

const NAV_SECTIONS = [
  { id: 'main', title: null, keys: ['welcome', 'news', 'employees', 'chats'] },
  { id: 'work', title: 'Продуктивность', keys: ['todo', 'tasks', 'kanban', 'vpr', 'orders'] },
  { id: 'calendar', title: null, keys: ['all-leaves', 'leaves', 'leaves-worktime'] },
  { id: 'admin', title: 'Администрирование', keys: ['worktime', 'admin'] },
];

/** «Заказы»: основной отдел Менеджер склада / Завсклад или тот же пункт в «Доступ к отделам». */
const WAREHOUSE_ORDERS_DEPARTMENTS = new Set([
  'Менеджер склада',
  'Завсклад (заведующий складом)',
  'Менеджер складу',
  'Завідувач складу',
]);

function userCanSeeWarehouseOrdersNav(user) {
  if (!user) return false;
  const norm = (s) => String(s || '').trim();
  const hit = (name) => WAREHOUSE_ORDERS_DEPARTMENTS.has(norm(name));
  return collectUserVisibilityLabels(user).some((label) => hit(label));
}

function isSidebarNavVisible(n, {
  user,
  sidebarVisibility,
  sidebarVisibilityLoaded,
  showKanbanButton,
  showLeavesWorktimeButton,
  waitUntilVisibilityLoaded = false,
} = {}) {
  if (!n) return false;
  const userRole = user?.role;
  const isAdminOrHR = isAdminOrHrRole(userRole);

  if (n.key !== 'admin' && n.key !== 'orders' && !isAdminOrHR) {
    if (waitUntilVisibilityLoaded && !sidebarVisibilityLoaded) return false;
    if (Object.keys(sidebarVisibility || {}).length > 0) {
      const visibilitySetting = sidebarVisibility[n.key];
      if (visibilitySetting === null || visibilitySetting === undefined) {
        // видна всем
      } else if (Array.isArray(visibilitySetting)) {
        // Совместимость: учитываем department + position + departments_access
        if (!userMatchesVisibilityList(user, visibilitySetting)) return false;
      } else if (visibilitySetting === false) {
        return false;
      }
    }
  }

  if (n.key === 'vpr') {
    const allDepartments = collectUserVisibilityLabels(user).map((d) => d.toLowerCase());
    const isAdmin = userRole === 'admin';
    const isDirector = userRole === 'руководитель' || userRole === 'director';
    const isAccountingRelated = allDepartments.some((dep) =>
      /бухгалтер|бухгалтерия|учёт|учет|финанс|cfo|логистик|закупок|оператор-учётчик|оператор-учетчик|финансовый отдел|отдел логистики|отдел закупок/i.test(dep)
    );
    if (!isAdmin && !isDirector && !isAccountingRelated) return false;
  }

  if (n.key === 'kanban') {
    const allDepartments = collectUserVisibilityLabels(user).map((d) => d.toLowerCase());
    const isAdmin = userRole === 'admin' || userRole === 'hr';
    const isDirector = userRole === 'руководитель' || userRole === 'director' || userRole === 'директор';
    const isDepartmentHead = isDepartmentHeadRole(userRole);
    const isFinanceRelated = allDepartments.some((dep) =>
      /бухгалтер|бухгалтерия|учёт|учет|финанс|cfo|фин\.?\s*отдел|финансовый/i.test(dep)
    );
    if (!isAdmin && !isDirector && !isDepartmentHead && !isFinanceRelated && !showKanbanButton) return false;
  }

  if (n.key === 'orders' && !userCanSeeWarehouseOrdersNav(user)) return false;
  if (n.key === 'worktime' && !isAdminOrHrRole(userRole)) return false;
  if (n.key === 'leaves-worktime' && !isAdminOrHrRole(userRole) && !showLeavesWorktimeButton) return false;
  return true;
}

const DEFAULT_APP_TITLE_SETTINGS = {
  text: 'Issa Plus',
  fontSize: '2em',
  fontFamily: 'Arial, sans-serif',
  customFontUrl: '',
  customFontName: '',
  color: '#43e97b',
  useGradient: false,
  gradientStart: '#43e97b',
  gradientEnd: '#2193b0',
  glowEnabled: true,
  glowColor: '#43e97b',
  glowIntensity: 12,
  glowSpread: 32,
  effectType: 'neon',
  snowmanEnabled: false,
  snowmanImage: null,
  snowmanPositionX: 0,
  snowmanPositionY: 0,
  snowmanScale: 100,
  snowmanPositionType: 'relative',
  avatarImage: null,
  avatarPositionX: 0,
  avatarPositionY: 0,
  avatarWidth: 88,
  avatarHeight: 88,
  // Настройки позиции и размера для текста "Issa Plus"
  textPositionX: 0,
  textPositionY: 0,
  // Настройки для текста "Мульти - мессенджер"
  subtitleText: 'Мульти - мессенджер',
  subtitleFontSize: '1.1em',
  subtitleColor: '#fff',
  subtitlePositionX: 0,
  subtitlePositionY: 0,
  welcomeScreenGoogleFontFamilies: [],
  welcomeScreenMobile: {},
  sidebarGoogleFontFamilies: [],
};

function getAppTitleSettings() {
  try {
    const saved = localStorage.getItem('appTitleSettings');
    if (saved) {
      return mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, JSON.parse(saved));
    }
  } catch (e) {
    console.error('Error loading app title settings:', e);
  }
  return DEFAULT_APP_TITLE_SETTINGS;
}

export default function SidebarNav({ onCloseMobileSidebar, onOpenMobileSidebar, isMobileNavModal = false, open = false, hideTitle = false }) {
  const { state: appState } = useApp();
  const [active, setActive] = useState('chats');
  const [appTitleSettings, setAppTitleSettings] = useState(getAppTitleSettings());
  const [sidebarVisibility, setSidebarVisibility] = useState({}); // Настройки видимости кнопок сайтбара
  const [sidebarVisibilityLoaded, setSidebarVisibilityLoaded] = useState(false);
  const [appTitleSettingsLoaded, setAppTitleSettingsLoaded] = useState(false);
  const canRenderNav = sidebarVisibilityLoaded && !!appState?.user && appTitleSettingsLoaded;
  
  // Отладка: проверяем, что hideTitle передается правильно
  React.useEffect(() => {
    if (hideTitle) {
      console.log('🔴 [SidebarNav] hideTitle=true, текст должен быть скрыт');
    } else {
      console.log('🟢 [SidebarNav] hideTitle=false, текст должен быть виден');
    }
  }, [hideTitle]);
  
  const isWinterSeason = React.useMemo(() => {
    const today = new Date();
    const month = today.getMonth(); // 0 - январь, 11 - декабрь
    const day = today.getDate();
    if (month === 11) return true; // декабрь
    if (month === 0) return true; // январь
    if (month === 1 && day <= 28) return true; // февраль до 28 включительно
    return false;
  }, []);
  
  // Делаем функцию загрузки видимости доступной глобально, чтобы можно было дергать при смене роли
  const loadSidebarVisibility = useCallback(async () => {
    try {
      const response = await fetch('/api/sidebar-visibility', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        if (result.success && result.visibility) {
          console.log('📥 Настройки видимости кнопок сайтбара загружены:', result.visibility);
          // Конвертируем старый формат (true/false) в новый (массив департаментов)
          const convertedVisibility = {};
          navs.forEach(nav => {
            const oldValue = result.visibility[nav.key];
            if (oldValue === false) {
              // Если была скрыта, делаем пустой массив (не видна никому, кроме админа/HR)
              convertedVisibility[nav.key] = [];
            } else if (Array.isArray(oldValue)) {
              // Уже новый формат
              convertedVisibility[nav.key] = oldValue;
            } else {
              // true или undefined - видна всем (null означает "видна всем")
              convertedVisibility[nav.key] = null;
            }
          });
          console.log('📥 Конвертированные настройки видимости:', convertedVisibility);
          setSidebarVisibility(convertedVisibility);
        } else {
          // По умолчанию все кнопки видимы всем (null = видна всем)
          const defaultVisibility = {};
          navs.forEach(nav => {
            defaultVisibility[nav.key] = null;
          });
          console.log('📥 Используются настройки по умолчанию (все видимы):', defaultVisibility);
          setSidebarVisibility(defaultVisibility);
        }
      } else {
        // Если ошибка (например, 403), используем настройки по умолчанию
        console.warn('⚠️ Не удалось загрузить настройки видимости (статус:', response.status, ')');
        const defaultVisibility = {};
        navs.forEach(nav => {
          defaultVisibility[nav.key] = null;
        });
        console.log('📥 Используются настройки по умолчанию из-за ошибки:', defaultVisibility);
        setSidebarVisibility(defaultVisibility);
      }
    } catch (error) {
      console.warn('⚠️ Не удалось загрузить настройки видимости:', error);
      // По умолчанию все кнопки видимы всем (null = видна всем)
      const defaultVisibility = {};
      navs.forEach(nav => {
        defaultVisibility[nav.key] = null;
      });
      setSidebarVisibility(defaultVisibility);
    } finally {
      setSidebarVisibilityLoaded(true);
    }
  }, [navs]);

  // Загрузка настроек видимости кнопок сайтбара
  useEffect(() => {
    // Делаем функцию доступной глобально для вызова из SocketProvider после смены роли
    window.reloadSidebarVisibility = loadSidebarVisibility;

    const init = async () => {
      try {
        await loadSidebarVisibility();
      } catch (e) {
        console.error('⚠️ Ошибка инициализации видимости сайдбара:', e);
      }
    };
    
    init();
    
    // Слушаем обновления видимости через WebSocket
    if (window.socket) {
      const handleVisibilityUpdate = (data) => {
        console.log('📡 Получены обновленные настройки видимости кнопок сайтбара:', data);
        if (data && data.visibility) {
          // Конвертируем старый формат (true/false) в новый (массив департаментов)
          const convertedVisibility = {};
          navs.forEach(nav => {
            const oldValue = data.visibility[nav.key];
            if (oldValue === false) {
              convertedVisibility[nav.key] = [];
            } else if (Array.isArray(oldValue)) {
              convertedVisibility[nav.key] = oldValue;
            } else {
              convertedVisibility[nav.key] = null;
            }
          });
          console.log('📡 Конвертированные настройки видимости (WebSocket):', convertedVisibility);
          setSidebarVisibility(convertedVisibility);
          setSidebarVisibilityLoaded(true);
        }
      };
      
      window.socket.on('sidebar-visibility-updated', handleVisibilityUpdate);
      
      return () => {
        if (window.socket) {
          window.socket.off('sidebar-visibility-updated', handleVisibilityUpdate);
        }
      };
    }
  }, []);
  
  // Загрузка глобальных настроек названия приложения (аватарка/позиции)
  useEffect(() => {
    const loadAppTitleSettings = async () => {
      try {
        const response = await fetch('/api/app-title-settings', {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        if (response.ok) {
          const result = await response.json();
          if (result.success && result.settings) {
            let localParsed = null;
            try {
              const ls = localStorage.getItem('appTitleSettings');
              if (ls) localParsed = JSON.parse(ls);
            } catch (e) {
              /* ignore */
            }
            const merged = unionWelcomeGoogleFontFamiliesInSettings(
              DEFAULT_APP_TITLE_SETTINGS,
              result.settings,
              localParsed
            );
            const normalized = mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, merged);
            setAppTitleSettings(normalized);
            localStorage.setItem('appTitleSettings', JSON.stringify(normalized));
          }
        }
      } catch (error) {
        console.warn('⚠️ Не удалось загрузить app title settings:', error);
      } finally {
        setAppTitleSettingsLoaded(true);
      }
    };
    loadAppTitleSettings();
  }, []);

  // Загрузка настроек названия приложения и загрузка кастомных шрифтов
  useEffect(() => {
    const settings = getAppTitleSettings();
    setAppTitleSettings(settings);
    
    // Загрузка кастомного шрифта, если указан URL
    if (settings.customFontUrl) {
      const existingLink = document.querySelector(`link[data-custom-font="${settings.customFontUrl}"]`);
      if (!existingLink) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = settings.customFontUrl;
        link.setAttribute('data-custom-font', settings.customFontUrl);
        document.head.appendChild(link);
      }
    }
    
    // Загрузка кастомного шрифта из локального файла (dataUrl)
    if (settings.customFontDataUrl && settings.customFontName) {
      const prevStyle = document.getElementById('custom-font-style');
      if (prevStyle) prevStyle.remove();
      const style = document.createElement('style');
      style.id = 'custom-font-style';
      style.innerHTML = `@font-face { font-family: '${settings.customFontName}'; src: url('${settings.customFontDataUrl}'); font-display: swap; }`;
      document.head.appendChild(style);
    }
    
    const handler = (e) => {
      console.log('🔄 SidebarNav: настройки названия/сайдбара обновлены', e?.type);
      let newSettings;
      const d = e?.detail;
      if (d?.settings && typeof d.settings === 'object' && !Array.isArray(d.settings)) {
        newSettings = mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, d.settings);
      } else if (d && typeof d === 'object' && !Array.isArray(d)) {
        newSettings = mergeAppTitleSettingsFromStorage(DEFAULT_APP_TITLE_SETTINGS, d);
      } else {
        newSettings = getAppTitleSettings();
      }
      console.log('🔄 SidebarNav: применяем настройки:', newSettings);
      setAppTitleSettings({ ...newSettings });

      if (newSettings.customFontUrl) {
        const existingLink = document.querySelector(`link[data-custom-font="${newSettings.customFontUrl}"]`);
        if (!existingLink) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = newSettings.customFontUrl;
          link.setAttribute('data-custom-font', newSettings.customFontUrl);
          document.head.appendChild(link);
        }
      }

      if (newSettings.customFontDataUrl && newSettings.customFontName) {
        const prevStyle = document.getElementById('custom-font-style');
        if (prevStyle) prevStyle.remove();
        const style = document.createElement('style');
        style.id = 'custom-font-style';
        style.innerHTML = `@font-face { font-family: '${newSettings.customFontName}'; src: url('${newSettings.customFontDataUrl}'); font-display: swap; }`;
        document.head.appendChild(style);
      } else if (!newSettings.customFontDataUrl && !newSettings.customFontUrl) {
        const prevStyle = document.getElementById('custom-font-style');
        if (prevStyle) prevStyle.remove();
      }
    };
    window.addEventListener('appTitleSettingsUpdated', handler);
    window.addEventListener('app-title-settings-updated', handler);
    window.addEventListener('sidebar-settings-updated', handler);
    return () => {
      window.removeEventListener('appTitleSettingsUpdated', handler);
      window.removeEventListener('app-title-settings-updated', handler);
      window.removeEventListener('sidebar-settings-updated', handler);
    };
  }, []);
  const [pendingCount, setPendingCount] = useState(0);
  const [myTasksCount, setMyTasksCount] = useState(0);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [showGeneralCalendar, setShowGeneralCalendar] = useState(false);
  const justOpenedGeneralCalendar = React.useRef(false);
  
  // Защищенная функция для закрытия модалки календаря
  const setShowGeneralCalendarSafe = React.useCallback((value) => {
    if (value === false && justOpenedGeneralCalendar.current) {
      console.log('SidebarNav: Предотвращено закрытие модалки календаря через setShowGeneralCalendar');
      return;
    }
    setShowGeneralCalendar(value);
  }, []);
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  });
  
  // Обновляем isMobile при изменении размера окна
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const welcomeModalAppTitleSettings = React.useMemo(
    () => (isMobile ? resolveAppTitleSettingsForMobileWelcome(appTitleSettings) : appTitleSettings),
    [isMobile, appTitleSettings]
  );

  const [showLeaveCalendar, setShowLeaveCalendar] = useState(false);
  const [showNewsModal, setShowNewsModal] = useState(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState(false);
  const [newsModalInitialAdd, setNewsModalInitialAdd] = useState(false);
  const [newsModalInitialPoll, setNewsModalInitialPoll] = useState(false);
  const [showTasksModal, setShowTasksModal] = useState(false);
  const [showChatsModal, setShowChatsModal] = useState(false);
  const [showChatAreaModal, setShowChatAreaModal] = useState(false);
  const [showCreateChatModal, setShowCreateChatModal] = useState(false);
  const [showWorkTimeModal, setShowWorkTimeModal] = useState(false);
  const [showVprModal, setShowVprModal] = useState(false);
  const [vprCreateTaskFile, setVprCreateTaskFile] = useState(null);
  const [showOrdersModal, setShowOrdersModal] = useState(false);
  const [showLeavesWorktimeModal, setShowLeavesWorktimeModal] = useState(false);
  const [initialWorktimeFilter, setInitialWorktimeFilter] = useState(null);
  const [showEmployeesModal, setShowEmployeesModal] = useState(false); // список сотрудников/чаты
  
  // Открытие модалки «Отработка отгулов» по событию (например, из уведомления HR «Перейти»)
  useEffect(() => {
    const handler = (e) => {
      setShowLeavesWorktimeModal(true);
      const filter = e.detail?.filter;
      if (filter) setInitialWorktimeFilter(filter);
    };
    window.addEventListener('show-leaves-worktime', handler);
    return () => window.removeEventListener('show-leaves-worktime', handler);
  }, []);

  // Открытие модалки по кнопке «Перейти» из уведомления сотрудника об окончании отработки
  useEffect(() => {
    const handler = (e) => {
      setShowLeavesWorktimeModal(true);
      const workType = e.detail?.workType;
      if (workType) setInitialWorktimeFilter(workType);
    };
    window.addEventListener('open-leaves-worktime-modal', handler);
    return () => window.removeEventListener('open-leaves-worktime-modal', handler);
  }, []);

  // ВПР: открыть «Создать задачу» с прикреплённым файлом расхождений
  useEffect(() => {
    const handler = (e) => {
      const file = e.detail?.file;
      if (file instanceof File) {
        setVprCreateTaskFile(file);
        setShowVprModal(false);
        setShowTasksModal(true);
      }
    };
    window.addEventListener('vpr-open-create-task', handler);
    return () => window.removeEventListener('vpr-open-create-task', handler);
  }, []);

  // Отладка: логируем изменения showLeavesWorktimeModal
  React.useEffect(() => {
    console.log('🔍 [SidebarNav] showLeavesWorktimeModal changed to:', showLeavesWorktimeModal);
  }, [showLeavesWorktimeModal]);

  // (debug removed)
  const [showBirthdaysModal, setShowBirthdaysModal] = useState(false); // дни рождения/поздравления
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [showEmojiSettingsModal, setShowEmojiSettingsModal] = useState(false);
  const [showTemplatesModal, setShowTemplatesModal] = useState(false);
  const [showUserRightsModal, setShowUserRightsModal] = useState(false);
  const [showOnecMassShutdownUserRights, setShowOnecMassShutdownUserRights] = useState(false);
  const [showTodoModal, setShowTodoModal] = useState(false);
  const [showKanbanModal, setShowKanbanModal] = useState(false);
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [showAppTitleSettingsModal, setShowAppTitleSettingsModal] = useState(false);
  const [showFrontendSettingsModal, setShowFrontendSettingsModal] = useState(false);
  const [showPendingRegModal, setShowPendingRegModal] = useState(false);
  const [portalKey, setPortalKey] = useState(0);
  const { state, dispatch } = useApp();
  const { isLight: ndIsLight, toggle: toggleNdTheme } = useNdTheme();
  const ndUserInitials = React.useMemo(() => {
    const name = String(state?.user?.username || '').trim();
    if (!name) return '?';
    const parts = name.split(/\s+/).filter(Boolean);
    return (parts.length > 1 ? parts[0][0] + parts[1][0] : name.slice(0, 2)).toUpperCase();
  }, [state?.user?.username]);
  const ndAvatarSrc = React.useMemo(() => {
    const raw = String(state?.user?.avatarUrl || '').trim();
    if (!raw) return null;
    if (/^(https?:|data:|blob:|\/)/i.test(raw)) return raw;
    if (raw.startsWith('uploads/')) return `/${raw}`;
    return `/uploads/avatars/${raw.replace(/^\/+/, '')}`;
  }, [state?.user?.avatarUrl]);
  const [showLeavesWorktimeButton, setShowLeavesWorktimeButton] = useState(false);
  const [showKanbanButton, setShowKanbanButton] = useState(false);
  const [sidebarTextAlign, setSidebarTextAlign] = useState('left');
  
  // Отслеживаем изменения CSS переменной --sidebar-text-align для обновления выравнивания
  useEffect(() => {
    const updateTextAlign = () => {
      if (typeof window !== 'undefined') {
        const align = getComputedStyle(document.documentElement).getPropertyValue('--sidebar-text-align').trim() || 'left';
        setSidebarTextAlign(align);
      }
    };
    
    updateTextAlign();
    
    // Периодически проверяем изменения (так как CSS переменные могут изменяться извне)
    const interval = setInterval(updateTextAlign, 100);
    
    // Также слушаем событие storage для синхронизации между вкладками
    window.addEventListener('storage', updateTextAlign);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', updateTextAlign);
    };
  }, []);
  // Admin users state
  const [adminUsers, setAdminUsers] = useState([]);
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminError, setAdminError] = useState('');
  const [adminHost, setAdminHost] = useState('');
  const [adminFilter, setAdminFilter] = useState('');
  const [adminEnabledFilter, setAdminEnabledFilter] = useState('all'); // all | enabled | disabled
  const [newName, setNewName] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [newNoExpire, setNewNoExpire] = useState(true);
  const [newAddRdp, setNewAddRdp] = useState(true);
  const [editRow, setEditRow] = useState(null); // {name, description, noExpire}
  // User rights states
  const [deptMap, setDeptMap] = useState({}); // { [userId]: department }
  const [departmentsAccessMap, setDepartmentsAccessMap] = useState({}); // { [userId]: string[] }
  const [employees, setEmployees] = useState([]);
  const [roleMap, setRoleMap] = useState({}); // { [userId]: role }
  const [positionMap, setPositionMap] = useState({}); // { [userId]: position }
  const [positions, setPositions] = useState([]); // Список должностей для выбора
  const [newPositionInput, setNewPositionInput] = useState('');
  const [openedPositionListForUser, setOpenedPositionListForUser] = useState(null);
  const [userRightsSearchFio, setUserRightsSearchFio] = useState('');
  // Орг-отделы для галочек «Доступ к отделам»
  
  const roles = [
    { value: 'user', label: 'Пользователь', color: '#10b981' },
    { value: 'department_head', label: 'Руководитель отдела', color: '#3b82f6' },
    { value: 'hr', label: 'HR', color: '#f59e0b' },
    { value: 'admin', label: 'Администратор', color: '#ef4444' },
    { value: 'director', label: 'Директор', color: '#8b5cf6' }
  ];

  // Маппинг для перевода украинских должностей на русские
  const translatePosition = (position) => {
    if (!position) return position;
    const translations = {
      'Організатор фотосесій': 'Организатор фотосессий',
      'Супервайзер КЦ': 'Супервайзер колл-центра',
      'Менеджер відділу повернень': 'Менеджер отдела возвратов',
      'Менеджер складу': 'Менеджер склада',
      'Оператор КЦ': 'Оператор колл-центра',
      'Менеджер відділу продажу': 'Менеджер отдела продаж',
      'Керівник фінансового відділу': 'Финансовый менеджер',
      'ВТК': 'ОТК (отдел технического контроля)',
      'SMM менеджер': 'SMM-менеджер',
      'Водій': 'Водитель',
      'Менеджер з дропшипінгу': 'Менеджер по дропшиппингу',
      'Менеджер з якості обслуговування клієнтів': 'Менеджер по качеству обслуживания клиентов',
      'Менеджер Маркетплейс': 'Менеджер маркетплейса',
      'Бухгалтер з первинної документації': 'Бухгалтер по первичной документации',
      'Керівник відділу закупок': 'Руководитель отдела закупок',
      'Супервайзер відділу повернень': 'Супервайзер отдела возвратов',
      'CEO': 'CEO (генеральный директор)',
      'Контент менеджер': 'Контент-менеджер',
      'Завідувач складу': 'Завсклад (заведующий складом)',
      'Системний адміністратор': 'Системный администратор',
      'Власник компанії': 'Владелец компании',
      'Помічник SMM-менеджера': 'Помощник SMM-менеджера',
      'Керівник відділу логістики': 'Руководитель отдела логистики',
      'HR-менеджер (менеджер по персоналу)': 'HR-менеджер (менеджер по персоналу)',
      'Менеджер відділу маркетингу': 'Менеджер отдела маркетинга',
      'Менеджер відділу закупок': 'Менеджер отдела закупок',
      'CFO': 'CFO (финансовый директор)',
      'Оператор обліковець': 'Оператор-учётчик'
    };
    return translations[position] || position;
  };

  const normalizePosition = (value) => String(value || '').trim();

  const positionExists = (list, value) => {
    const normalized = normalizePosition(value).toLowerCase();
    return list.some((item) => normalizePosition(item).toLowerCase() === normalized);
  };

  const handleAddPosition = () => {
    const normalized = normalizePosition(newPositionInput);
    if (!normalized) return;
    setPositions((prev) => {
      if (positionExists(prev, normalized)) return prev;
      return [...prev, normalized].sort((a, b) => a.localeCompare(b, 'ru'));
    });
    setNewPositionInput('');
  };

  const handleDeletePosition = (positionToDelete) => {
    const normalized = normalizePosition(positionToDelete);
    if (!normalized) return;
    const inUse = (employees || []).some((emp) => {
      const assigned = normalizePosition(positionMap?.[emp.id] || emp.position);
      return assigned.toLowerCase() === normalized.toLowerCase();
    });
    if (inUse) {
      alert(`Нельзя удалить должность "${normalized}", она назначена сотрудникам.`);
      return;
    }
    setPositions((prev) =>
      prev.filter((item) => normalizePosition(item).toLowerCase() !== normalized.toLowerCase())
    );
  };

  // Открытие «Права» поверх текущего стека (список компании остаётся под слоем)
  useEffect(() => {
    const onRequest = () => setShowUserRightsModal(true);
    window.addEventListener('openUserRightsModalRequest', onRequest);
    return () => window.removeEventListener('openUserRightsModalRequest', onRequest);
  }, []);

  // Load employees when user rights modal opens
  useEffect(() => {
    if (!showUserRightsModal) return;
    if (!window.socket) return;

    const handleAllUsers = (users) => {
      setEmployees(users || []);
    };

    window.socket.emit('get_all_users');
    window.socket.on('all_users', handleAllUsers);

    return () => {
      window.socket.off('all_users', handleAllUsers);
    };
  }, [showUserRightsModal]);

  // Load positions from company_structure when user rights modal opens
  useEffect(() => {
    if (!showUserRightsModal) return;
    
    const loadPositions = async () => {
      try {
        console.log('📋 [SidebarNav] Загрузка должностей для десктопной модалки...');
        const token = localStorage.getItem('token');
        const response = await fetch('/api/company-structure/list', {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          // Получаем уникальные должности из company_structure и переводим на русский
          const uniquePositions = [...new Set(
            (Array.isArray(data) ? data : [])
              .map(emp => emp.position)
              .filter(pos => pos && pos.trim() !== '')
              .map(pos => translatePosition(pos))
          )].sort();
          console.log('📋 [SidebarNav] Уникальные должности (на русском):', uniquePositions);
          setPositions([...new Set([...JOB_TITLES, ...uniquePositions])].sort((a, b) => String(a).localeCompare(String(b), 'ru')));
        }
      } catch (error) {
        console.error('📋 [SidebarNav] Ошибка загрузки должностей:', error);
      }
    };
    
    loadPositions();
  }, [showUserRightsModal]);

  // Initialize dept map, role map, position map and departments access map from employees
  useEffect(() => {
    const deptMapLocal = {};
    const roleMapLocal = {};
    const positionMapLocal = {};
    const departmentsAccessLocal = {};
    (employees || []).forEach(u => {
      if (!u?.id) return;
      if (u.department != null) deptMapLocal[u.id] = u.department || '';
      if (u.role) roleMapLocal[u.id] = u.role;
      if (u.position != null) {
        positionMapLocal[u.id] = u.position ? translatePosition(u.position) : '';
      }
      // Эффективный доступ: access + орг-отдел из department (чтобы галочки не «пропадали» после F5)
      departmentsAccessLocal[u.id] = effectiveOrgAccessList(u);
    });
    setDeptMap((prev) => ({ ...prev, ...deptMapLocal }));
    if (Object.keys(roleMapLocal).length) setRoleMap((prev) => ({ ...prev, ...roleMapLocal }));
    setPositionMap((prev) => ({ ...prev, ...positionMapLocal }));
    setDepartmentsAccessMap((prev) => ({ ...prev, ...departmentsAccessLocal }));
  }, [employees]);

  // Один раз за открытие модалки: если в department орг-отдел, а в access его нет — дописать в access (починка после старого бага)
  const repairedAccessRef = useRef(false);
  useEffect(() => {
    if (!showUserRightsModal) {
      repairedAccessRef.current = false;
      return;
    }
    if (!employees?.length || repairedAccessRef.current) return;
    repairedAccessRef.current = true;
    (employees || []).forEach((u) => {
      if (!u?.id) return;
      const stored = Array.isArray(u.departments_access) ? u.departments_access : [];
      const effective = effectiveOrgAccessList(u);
      const needPersist = effective.some(
        (d) => isOrgDepartment(d) && !accessListIncludes(stored, d)
      );
      if (needPersist) {
        const legacy = stored.filter((d) => !isOrgDepartment(d));
        const orgs = effective.filter((d) => isOrgDepartment(d));
        setDepartmentsAccess(u.id, [...orgs, ...legacy]);
      }
    });
  }, [showUserRightsModal, employees]);

  // Department management function
  const setDepartment = async (userId, department) => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/users/${userId}/department`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ department })
      });
      if (res.ok) {
        const next = { ...(deptMap || {}) };
        if (department) next[userId] = department; else delete next[userId];
        setDeptMap(next);
        if (window.socket) window.socket.emit('get_all_users');
        return true;
      }
    } catch (error) {
      console.error('Error setting department:', error);
    }
    
    // Fallback: socket event
    try {
      if (window.socket && window.socket.connected) {
        window.socket.emit('set_user_department', { userId, department });
        const next = { ...(deptMap || {}) };
        if (department) next[userId] = department; else delete next[userId];
        setDeptMap(next);
        return true;
      }
    } catch (error) {
      console.error('Socket error:', error);
    }
    
    return false;
  };

  // Position management function
  const setPosition = async (userId, position) => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/users/${userId}/position`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ position })
      });
      if (res.ok) {
        const next = { ...(positionMap || {}) };
        if (position) next[userId] = position; else delete next[userId];
        setPositionMap(next);

        // Сразу обновляем текущего пользователя — иначе в блоке у аватара должность не видна
        if (state.user && Number(state.user.id) === Number(userId)) {
          const updatedUser = { ...state.user, position: position || '' };
          localStorage.setItem('user', JSON.stringify(updatedUser));
          dispatch({ type: 'SET_USER', payload: updatedUser });
        }
        
        // Если это новая должность, добавляем её в список
        if (position && position.trim() !== '') {
          setPositions((prev) => {
            if (positionExists(prev, position)) return prev;
            return [...prev, normalizePosition(position)].sort((a, b) => a.localeCompare(b, 'ru'));
          });
        }
        
        if (window.socket) window.socket.emit('get_all_users');
        return true;
      }
    } catch (error) {
      console.error('Error setting position:', error);
    }
    
    // Fallback: socket event
    try {
      if (window.socket && window.socket.connected) {
        window.socket.emit('set_user_position', { userId, position });
        const next = { ...(positionMap || {}) };
        if (position) next[userId] = position; else delete next[userId];
        setPositionMap(next);

        if (state.user && Number(state.user.id) === Number(userId)) {
          const updatedUser = { ...state.user, position: position || '' };
          localStorage.setItem('user', JSON.stringify(updatedUser));
          dispatch({ type: 'SET_USER', payload: updatedUser });
        }
        
        // Если это новая должность, добавляем её в список
        if (position && position.trim() !== '') {
          setPositions((prev) => {
            if (positionExists(prev, position)) return prev;
            return [...prev, normalizePosition(position)].sort((a, b) => a.localeCompare(b, 'ru'));
          });
        }
        
        return true;
      }
    } catch (error) {
      console.error('Socket error:', error);
    }
    
    return false;
  };

  // Departments access management function (multiple departments)
  const setDepartmentsAccess = async (userId, departmentsList) => {
    const token = localStorage.getItem('token');
    const list = Array.isArray(departmentsList) ? departmentsList : [];
    try {
      const res = await fetch(`/api/users/${userId}/departments-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ departments: list })
      });
      if (res.ok) {
        let data = {};
        try { data = await res.json(); } catch (_) {}
        const next = { ...(departmentsAccessMap || {}) };
        next[userId] = Array.isArray(data.departments_access) ? data.departments_access : list;
        setDepartmentsAccessMap(next);
        // department синхронизирует сервер — только обновим локальный map
        if (Object.prototype.hasOwnProperty.call(data, 'department')) {
          setDeptMap((prev) => {
            const copy = { ...(prev || {}) };
            if (data.department) copy[userId] = data.department;
            else delete copy[userId];
            return copy;
          });
        } else {
          const currentDept = deptMap?.[userId] || '';
          const syncedDept = nextDepartmentAfterAccessChange(list, currentDept);
          if (syncedDept !== null) {
            setDeptMap((prev) => {
              const copy = { ...(prev || {}) };
              if (syncedDept) copy[userId] = syncedDept;
              else delete copy[userId];
              return copy;
            });
          }
        }
        if (window.socket) window.socket.emit('get_all_users');
        return true;
      }
      console.warn('departments-access HTTP', res.status);
    } catch (error) {
      console.error('Error setting departments access (SidebarNav):', error);
    }

    // Fallback через сокет
    try {
      if (window.socket && window.socket.connected) {
        window.socket.emit('set_user_departments_access', {
          userId,
          departments: list
        });
        const next = { ...(departmentsAccessMap || {}) };
        next[userId] = list;
        setDepartmentsAccessMap(next);
        const currentDept = deptMap?.[userId] || '';
        const syncedDept = nextDepartmentAfterAccessChange(list, currentDept);
        if (syncedDept !== null) {
          setDeptMap((prev) => {
            const copy = { ...(prev || {}) };
            if (syncedDept) copy[userId] = syncedDept;
            else delete copy[userId];
            return copy;
          });
        }
        return true;
      }
    } catch (error) {
      console.error('Socket error (departments access, SidebarNav):', error);
    }

    return false;
  };

  // Role management function
  const setUserRole = async (userId, role) => {
    const token = localStorage.getItem('token');
    try {
      const res = await fetch(`/api/users/${userId}/role`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        },
        body: JSON.stringify({ role })
      });
      if (res.ok) {
        const next = { ...(roleMap || {}) };
        if (role) next[userId] = role; else delete next[userId];
        setRoleMap(next);
        if (window.socket) window.socket.emit('get_all_users');
        return true;
      }
    } catch (error) {
      console.error('Error setting role:', error);
    }
    
    // Fallback: socket event
    try {
      if (window.socket && window.socket.connected) {
        window.socket.emit('set_user_role', { userId, role });
        const next = { ...(roleMap || {}) };
        if (role) next[userId] = role; else delete next[userId];
        setRoleMap(next);
        return true;
      }
    } catch (error) {
      console.error('Socket error:', error);
    }
    
    return false;
  };

  // Функция для получения или создания контейнера порталов
  const getModalRoot = React.useCallback(() => {
    if (typeof document === 'undefined') return null;
    let el = document.getElementById('app-modal-root');
    if (!el) {
      el = document.createElement('div');
      el.id = 'app-modal-root';
      el.style.position = 'fixed';
      el.style.top = '0';
      el.style.left = '0';
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.pointerEvents = 'none';
      // Выше мобильного оверлея навигации (100001), иначе модалки из портала не получают клики
      el.style.zIndex = '200000';
      el.style.isolation = 'isolate'; // Создаем новый stacking context
      try {
        document.body.appendChild(el);
      } catch (error) {
        console.warn('Failed to append modal root:', error);
        return null;
      }
    }
    // Проверяем, что элемент все еще в DOM
    if (!document.body.contains(el)) {
      try {
        document.body.appendChild(el);
      } catch (error) {
        console.warn('Failed to re-append modal root:', error);
        return null;
      }
    }
    // Убеждаемся, что стили установлены правильно
    el.style.position = 'fixed';
    el.style.top = '0';
    el.style.left = '0';
    el.style.width = '100%';
    el.style.height = '100%';
    el.style.pointerEvents = 'none';
    el.style.zIndex = '200000';
    el.style.isolation = 'isolate';
    return el;
  }, []);

  // Безопасное создание портала с дополнительными проверками
  const createSafePortal = (component, condition, options = {}) => {
    if (!condition) {
      return null;
    }
    
    try {
      const root = options.useNestedModalRoot ? getMessengerNestedModalRoot() : getModalRoot();
      if (!root) {
        console.warn('🔍 createSafePortal: Cannot get modal root, skipping portal creation');
        return null;
      }
      // #app-modal-root — pointer-events: none; nested root — поверх модалок в document.body (список компании ~1e6)
      const portal = ReactDOM.createPortal(component, root);
      console.log('✅ createSafePortal: Portal created for condition:', condition, 'root:', root);
      return portal;
    } catch (error) {
      console.error('❌ createSafePortal: Failed to create portal:', error);
      return null;
    }
  };

  // Универсальное закрытие всех модалок (для адаптивности и UX)
  const closeAllModals = React.useCallback(() => {
    // Не закрываем модалку календаря, если она только что была открыта
    if (justOpenedGeneralCalendar.current) {
      console.log('SidebarNav: Предотвращено закрытие модалки календаря (только что открыта)');
      return;
    }
    // Сначала закрываем вложенные модалки
    setShowEmojiSettingsModal(false);
    setShowTemplatesModal(false);
    setShowAppTitleSettingsModal(false);
    setShowUserRightsModal(false);
    setShowPendingRegModal(false);
    setShowFrontendSettingsModal(false);
    // Затем закрываем основные модалки
    setShowUploadModal(false);
    setShowAdminModal(false);
    setShowGeneralCalendarSafe(false);
    setShowLeaveCalendar(false);
    setShowNewsModal(false);
    setShowWelcomeModal(false);
    setShowTasksModal(false);
    setShowChatsModal(false);
    setShowChatAreaModal(false);
    setShowCreateChatModal(false);
    setShowWorkTimeModal(false);
    setShowLeavesWorktimeModal(false);
    setShowEmployeesModal(false);
    setShowBirthdaysModal(false);
    setShowTodoModal(false);
    setShowKanbanModal(false);
    setShowRatingModal(false);
    setShowOrdersModal(false);
    setShowVprModal(false);
    setPortalKey(k => k + 1);
    // #app-modal-root остаётся pointer-events: none
  }, [setShowGeneralCalendarSafe]);

  // Отслеживание изменения размера окна для определения мобильного устройства
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Закрытие по Esc и по глобальному событию
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') closeAllModals();
    };
    const onCloseAll = () => {
      // Не закрываем модалку календаря, если она только что была открыта
      if (justOpenedGeneralCalendar.current) {
        console.log('SidebarNav: onCloseAll - предотвращено закрытие модалки календаря');
        return;
      }
      closeAllModals();
    };
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('close-all-modals', onCloseAll);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('close-all-modals', onCloseAll);
    };
  }, [closeAllModals]);

  // Инициализация modal root при монтировании
  useEffect(() => {
    // Убеждаемся, что modal root создан при монтировании
    getModalRoot();
  }, [getModalRoot]);

  // #app-modal-root поверх #root по z-index; pointer-events: none (+ GlobalStyles !important) — клики в пустых
  // зонах доходят до сайдбара. Десктоп «Управление» рендерится в document.body, минуя этот корень.
  useEffect(() => {
    const root = getModalRoot();
    if (!root) return undefined;
    root.style.pointerEvents = 'none';
    return undefined;
  }, [getModalRoot]);

  useEffect(() => {
    if (!isMobile || !showWelcomeModal) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isMobile, showWelcomeModal]);

  // Проверка, показывать ли кнопку "Отработка отгулов"
  useEffect(() => {
    const checkLeavesWorktime = async () => {
      const token = localStorage.getItem('token');
      const role = state.user?.role;
      if (role === 'hr' || role === 'admin' || role === 'руководитель') {
        setShowLeavesWorktimeButton(true);
        return;
      }
      if (!token) { setShowLeavesWorktimeButton(false); return; }
      try {
        const res = await fetch('/api/leaves-worktime-report', { headers: { Authorization: `Bearer ${token}` } });
        const data = await res.json();
        setShowLeavesWorktimeButton(Array.isArray(data) && data.length > 0);
      } catch {
        setShowLeavesWorktimeButton(false);
      }
    };
    checkLeavesWorktime();
    // Подписка на событие обновления отгулов (срабатывает у того, кто одобрил; у сотрудника — периодическая проверка ниже)
    const handler = () => checkLeavesWorktime();
    window.addEventListener('leaves-worktime-updated', handler);
    // При возврате на вкладку — сразу перепроверить (после одобрения админом)
    const onVisibilityChange = () => { if (document.visibilityState === 'visible') checkLeavesWorktime(); };
    document.addEventListener('visibilitychange', onVisibilityChange);
    // Периодическая проверка для сотрудника: после одобрения админом кнопка появится без перезагрузки страницы (раз в минуту)
    const interval = setInterval(checkLeavesWorktime, 60000);
    return () => {
      window.removeEventListener('leaves-worktime-updated', handler);
      document.removeEventListener('visibilitychange', onVisibilityChange);
      clearInterval(interval);
    };
  }, [state.user]);

  // Доступ к канбану (фин. отдел / участник / привилегированные роли — на сервере)
  useEffect(() => {
    const checkKanban = async () => {
      const token = localStorage.getItem('token');
      if (!token) { setShowKanbanButton(false); return; }
      try {
        const res = await fetch('/api/kanban/access', { headers: { Authorization: `Bearer ${token}` } });
        if (!res.ok) { setShowKanbanButton(false); return; }
        const data = await res.json();
        setShowKanbanButton(!!data.allowed);
      } catch {
        setShowKanbanButton(false);
      }
    };
    checkKanban();
  }, [state.user]);

  // Счетчик новых новостей
  useEffect(() => {
    async function fetchNewsCount() {
      try {
        const token = localStorage.getItem('token');
        if (!token) return dispatch({ type: 'RESET_UNREAD_NEWS' });
        const res = await fetch('/api/news', { headers: { Authorization: `Bearer ${token}` } });
        const newsArr = await res.json();
        const lastReadId = Number(localStorage.getItem('lastNewsId') || 0);
        if (newsArr && newsArr.length > 0) {
          const idx = newsArr.findIndex(n => n.id === lastReadId);
          dispatch({ type: 'SET_UNREAD_NEWS_COUNT', payload: idx === -1 ? newsArr.length : idx });
        } else {
          dispatch({ type: 'RESET_UNREAD_NEWS' });
        }
      } catch {
        dispatch({ type: 'RESET_UNREAD_NEWS' });
      }
    }
    fetchNewsCount();
    const handleNewsRead = () => fetchNewsCount();
    window.addEventListener('news-read', handleNewsRead);
    return () => window.removeEventListener('news-read', handleNewsRead);
  }, [dispatch]);

  // Получение количества заявок в статусе pending
  const fetchPendingCount = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch('/api/all-leaves', { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setPendingCount(data.filter(l => l.status === 'pending').length);
        }
      })
      .catch(() => setPendingCount(0));
  }, []);

  // Получение количества открытых задач для текущего пользователя
  const fetchMyTasksCount = useCallback(() => {
    const token = localStorage.getItem('token');
    if (!token || !state.user) return;
    const apiUrl = typeof window !== 'undefined' && window.location ? window.location.origin : '';
    fetch(`${apiUrl}/api/tasks/open`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          // Получаем просмотренные задачи
          let viewed = JSON.parse(localStorage.getItem('viewedTasks') || '[]');
          // Считаем только задачи, назначенные текущему пользователю и не просмотренные
          setMyTasksCount(data.filter(t => String(t.assignedTo) === String(state.user.id) && !viewed.includes(t.id)).length);
        }
      })
      .catch(() => setMyTasksCount(0));
  }, [state.user]);

  useEffect(() => {
    const set = (k) => () => setActive(k);
    window.addEventListener('show-chats', set('chats'));
    window.addEventListener('show-leaves', set('leaves'));
    window.addEventListener('show-tasks', set('tasks'));
    window.addEventListener('show-news', set('news'));
    window.addEventListener('show-welcome', set('welcome'));
    window.addEventListener('show-employees', set('employees'));
    const openAdminFromEvent = () => {
      setActive('admin');
      setShowAdminModal(true);
    };
    window.addEventListener('show-admin', openAdminFromEvent);
    const openPendingRegFromEvent = () => setShowPendingRegModal(true);
    window.addEventListener('open-pending-registrations', openPendingRegFromEvent);
    
    // Загружаем количество заявок и задач при монтировании
    fetchPendingCount();
    fetchMyTasksCount();

    // Polling для новых сообщений в чатах
    async function fetchUnreadChats() {
      try {
        const token = localStorage.getItem('token');
        if (!token || !state.user) return dispatch({ type: 'SET_UNREAD_CHATS', payload: 0 });
        const res = await fetch('/api/chats/unread', { headers: { Authorization: `Bearer ${token}` } });
        const data = await res.json();
        // Поддерживаем оба формата ответа: массив непрочитанных или объект { unreadCount }
        const count = Array.isArray(data) ? data.length : (typeof data?.unreadCount === 'number' ? data.unreadCount : 0);
        dispatch({ type: 'SET_UNREAD_CHATS', payload: count });
      } catch {
        dispatch({ type: 'SET_UNREAD_CHATS', payload: 0 });
      }
    }

    // Обновлять каждые 5 секунд
    const interval = setInterval(() => {
      fetchPendingCount();
      fetchMyTasksCount();
      fetchUnreadChats();
    }, 5000);

    // Также обновлять при открытии календаря
    window.addEventListener('show-all-leaves', fetchPendingCount);
    window.addEventListener('show-tasks', fetchMyTasksCount);
    
    // Обработчик для модалки рейтинга
    window.addEventListener('show-employee-rating', () => setShowRatingModal(true));

    return () => {
      window.removeEventListener('show-chats', set('chats'));
      window.removeEventListener('show-leaves', set('leaves'));
      window.removeEventListener('show-tasks', set('tasks'));
      window.removeEventListener('show-news', set('news'));
      window.removeEventListener('show-welcome', set('welcome'));
      window.removeEventListener('show-employees', set('employees'));
      window.removeEventListener('show-admin', openAdminFromEvent);
      window.removeEventListener('open-pending-registrations', openPendingRegFromEvent);
      window.removeEventListener('show-all-leaves', fetchPendingCount);
      window.removeEventListener('show-tasks', fetchMyTasksCount);
      window.removeEventListener('show-employee-rating', () => setShowRatingModal(true));
      clearInterval(interval);
    };
  }, [fetchPendingCount, fetchMyTasksCount, state.user, dispatch]);

  // Admin: load local users when modal opens
  useEffect(() => {
    async function loadUsers() {
      const token = localStorage.getItem('token');
      if (!token) return;
      
      // Проверяем, не является ли сервер Linux (кэшируем результат)
      const isLinuxServer = sessionStorage.getItem('admin_is_linux_server') === 'true';
      if (isLinuxServer) {
        setAdminError('Управление локальными пользователями доступно только на Windows-серверах');
        setAdminUsers([]);
        setAdminLoading(false);
        return;
      }
      
      setAdminLoading(true);
      setAdminError('');
      try {
        // hostname (for clarity where users are created)
        try {
          const rh = await fetch('/api/admin/host', { headers: { Authorization: `Bearer ${token}` } });
          if (rh.ok) {
          const hd = await rh.json();
          if (hd && hd.success && hd.host) setAdminHost(hd.host);
          }
        } catch {}
        try {
        const r = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${token}` } });
          if (r.ok) {
            try {
        const data = await r.json();
        if (Array.isArray(data)) setAdminUsers(data);
        else setAdminUsers([]);
            } catch (jsonError) {
              console.error('Ошибка парсинга JSON:', jsonError);
              setAdminError('Не удалось обработать ответ сервера');
              setAdminUsers([]);
            }
          } else {
            // Пытаемся прочитать сообщение об ошибке
            let errorMessage = `Сервер вернул ошибку ${r.status}`;
            let isWindowsError = false;
            try {
              const errorText = await r.text();
              try {
                const errorJson = JSON.parse(errorText);
                if (errorJson.error) {
                  errorMessage = errorJson.error;
                  // Понятные сообщения для известных ошибок
                  if (errorMessage.includes('powershell.exe') || errorMessage.includes('Windows systems') || errorMessage.includes('only available on Windows')) {
                    errorMessage = 'Управление локальными пользователями доступно только на Windows-серверах';
                    isWindowsError = true;
                    // Кэшируем, что сервер на Linux, чтобы не делать повторные запросы
                    sessionStorage.setItem('admin_is_linux_server', 'true');
                  } else if (errorMessage.includes('ENOENT')) {
                    errorMessage = 'Ошибка: системная команда недоступна на данном сервере';
                  }
                } else if (errorJson.message) {
                  errorMessage = errorJson.message;
                  if (errorMessage.includes('Windows systems') || errorMessage.includes('only available on Windows')) {
                    errorMessage = 'Управление локальными пользователями доступно только на Windows-серверах';
                    isWindowsError = true;
                    // Кэшируем, что сервер на Linux, чтобы не делать повторные запросы
                    sessionStorage.setItem('admin_is_linux_server', 'true');
                  }
                }
              } catch {
                // Если не JSON, оставляем текст как есть
                if (errorText && errorText.length < 200) {
                  errorMessage = errorText;
                  if (errorMessage.includes('Windows systems') || errorMessage.includes('only available on Windows')) {
                    errorMessage = 'Управление локальными пользователями доступно только на Windows-серверах';
                    isWindowsError = true;
                    // Кэшируем, что сервер на Linux, чтобы не делать повторные запросы
                    sessionStorage.setItem('admin_is_linux_server', 'true');
                  }
                }
              }
            } catch {}
            
            // Для ошибок Windows не логируем в консоль, так как это ожидаемое поведение
            if (!isWindowsError) {
              console.error('Ошибка загрузки пользователей:', r.status, r.statusText);
            }
            
            setAdminError(isWindowsError ? errorMessage : `Не удалось получить пользователей: ${errorMessage}`);
            setAdminUsers([]);
          }
      } catch (e) {
          console.error('Ошибка запроса пользователей:', e);
          setAdminError('Не удалось получить пользователей: ' + (e.message || 'неизвестная ошибка'));
          setAdminUsers([]);
        }
      } catch (e) {
        console.error('Общая ошибка загрузки:', e);
        setAdminError('Не удалось получить пользователей: ' + (e.message || 'неизвестная ошибка'));
        setAdminUsers([]);
      } finally {
        setAdminLoading(false);
      }
    }
    if (showAdminModal) loadUsers();
  }, [showAdminModal]);

  async function adminCreateUser(addRdpParam) {
    const token = localStorage.getItem('token');
    try {
      const r = await fetch('/api/admin/local-users', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ name: newName, password: newPassword, description: newDescription, noExpire: newNoExpire, addToRdp: (typeof addRdpParam === 'boolean' ? addRdpParam : newAddRdp) })
      });
      const data = await r.json();
      if (!r.ok || data?.success === false) throw new Error(data?.error || 'Ошибка создания');
      const createdName = newName;
      setNewName(''); setNewPassword(''); setNewDescription(''); setNewNoExpire(true); setNewAddRdp(true);
      // reload
      const rr = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${token}` } });
      const users = await rr.json();
      setAdminUsers(Array.isArray(users) ? users : []);
      // Явно добавить в RDP после создания, если выбрано (поверх серверной логики)
      const needAdd = (typeof addRdpParam === 'boolean' ? addRdpParam : newAddRdp);
      if (needAdd && createdName) {
        try {
          await fetch(`/api/admin/local-users/${encodeURIComponent(createdName)}/rdp`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, body: JSON.stringify({ add: true }) });
        } catch {}
      }
      alert('Пользователь создан');
    } catch (e) {
      alert('Ошибка: ' + e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  async function adminSetPassword(name) {
    const pwd = window.prompt('Введите новый пароль для ' + name);
    if (!pwd) return;
    const token = localStorage.getItem('token');
    try {
      const r = await fetch(`/api/admin/local-users/${encodeURIComponent(name)}/password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ password: pwd })
      });
      const data = await r.json();
      if (!r.ok || data?.success === false) throw new Error(data?.error || 'Ошибка');
      alert('Пароль обновлен');
    } catch (e) {
      alert('Ошибка: ' + e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  async function adminEnable(name, enable) {
    const token = localStorage.getItem('token');
    try {
      const r = await fetch(`/api/admin/local-users/${encodeURIComponent(name)}/${enable ? 'enable' : 'disable'}`, { method: 'POST', headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (!r.ok || data?.success === false) throw new Error(data?.error || 'Ошибка');
      // refresh list
      const rr = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${token}` } });
      const users = await rr.json();
      setAdminUsers(Array.isArray(users) ? users : []);
    } catch (e) {
      alert('Ошибка: ' + e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  async function adminDelete(name) {
    if (!window.confirm('Удалить пользователя ' + name + '?')) return;
    const token = localStorage.getItem('token');
    try {
      const r = await fetch(`/api/admin/local-users/${encodeURIComponent(name)}`, { method: 'DELETE', headers: { Authorization: `Bearer ${token}` } });
      const data = await r.json();
      if (!r.ok || data?.success === false) throw new Error(data?.error || 'Ошибка');
      // refresh list
      const rr = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${token}` } });
      const users = await rr.json();
      setAdminUsers(Array.isArray(users) ? users : []);
    } catch (e) {
      alert('Ошибка: ' + e.message);
    }
  }

  // eslint-disable-next-line no-unused-vars
  async function adminRdp(name, add) {
    const token = localStorage.getItem('token');
    try {
      const r = await fetch(`/api/admin/local-users/${encodeURIComponent(name)}/rdp`, { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ add }) });
      const data = await r.json();
      if (!r.ok || data?.success === false) throw new Error(data?.error || 'Ошибка');
      alert(add ? 'Добавлен в группу RDP' : 'Удален из группы RDP');
    } catch (e) {
      alert('Ошибка: ' + e.message);
    }
  }

  // Пример добавления новых задач/новостей через событие:
  useEffect(() => {
    function onNewTask() { setMyTasksCount(c => c + 1); }
    function onResetTasksCount() { setMyTasksCount(0); }
    window.addEventListener('new-task', onNewTask);
    window.addEventListener('reset-tasks-count', onResetTasksCount);
    return () => {
      window.removeEventListener('new-task', onNewTask);
      window.removeEventListener('reset-tasks-count', onResetTasksCount);
    };
  }, []);

  useEffect(() => {
    function onNewsPublished(e) {
      console.log('SidebarNav: PUSH news-published', e.detail);
      dispatch({ type: 'SET_UNREAD_NEWS_COUNT', payload: state.unreadNews + 1 });
    }
    window.addEventListener('news-published', onNewsPublished);
    return () => window.removeEventListener('news-published', onNewsPublished);
  }, [state.unreadNews, dispatch]);

  // Резерв: открытие модалки новостей с формой добавления/опроса (например из кастомных кнопок)
  useEffect(() => {
    function onOpenNewsModal(e) {
      const detail = e?.detail || {};
      setNewsModalInitialAdd(!!detail.add);
      setNewsModalInitialPoll(!!detail.poll);
      setShowWelcomeModal(false);
      setShowNewsModal(true);
    }
    window.addEventListener('open-news-modal', onOpenNewsModal);
    return () => window.removeEventListener('open-news-modal', onOpenNewsModal);
  }, []);

  const handleNavClick = (n) => {
    setActive(n.key);
    
    // Определяем, является ли это модалкой
    const isModal = ['all-leaves', 'tasks', 'news', 'welcome', 'todo', 'kanban', 'leaves', 'chats', 'employees', 'worktime', 'vpr', 'orders', 'leaves-worktime', 'admin'].includes(n.key);
    
    // Для модалок: сначала открываем модалку, потом закрываем сайдбар
    // Для не-модалок: закрываем все модалки и сайдбар
    if (isModal) {
      // Сначала закрываем все модалки синхронно, чтобы предотвратить конфликты z-index
      // Для модалок: закрываем только другие модалки (не ту, которую открываем)
      // НЕ вызываем closeAllModals() и не отправляем событие close-all-modals,
      // чтобы не закрыть модалку, которую мы только что открыли
      if (n.key !== 'all-leaves') setShowGeneralCalendarSafe(false);
      if (n.key !== 'leaves') setShowLeaveCalendar(false);
      if (n.key !== 'news') setShowNewsModal(false);
      if (n.key !== 'welcome') setShowWelcomeModal(false);
      if (n.key !== 'tasks') setShowTasksModal(false);
      if (n.key !== 'todo') setShowTodoModal(false);
      if (n.key !== 'kanban') setShowKanbanModal(false);
      if (n.key !== 'chats') {
        setShowChatsModal(false);
        setShowChatAreaModal(false);
      }
      // Закрываем остальные модалки
      if (n.key !== 'worktime') setShowWorkTimeModal(false);
      if (n.key !== 'vpr') setShowVprModal(false);
      if (n.key !== 'orders') setShowOrdersModal(false);
      if (n.key !== 'leaves-worktime') setShowLeavesWorktimeModal(false);
      if (n.key !== 'employees') {
        setShowEmployeesModal(false);
        setShowBirthdaysModal(false);
        setShowRatingModal(false);
      }
      if (n.key !== 'admin') setShowAdminModal(false);
      // Закрываем модалку загрузки файлов и все вложенные модалки
      setShowUploadModal(false);
      setShowEmojiSettingsModal(false);
      setShowTemplatesModal(false);
      setShowAppTitleSettingsModal(false);
      setShowUserRightsModal(false);
      setShowPendingRegModal(false);
      setShowFrontendSettingsModal(false);

      // Десктоп «Управление»: сразу открываем; рендер AdminDesktop — отдельным порталом в body (не внутри #app-modal-root).
      if (n.key === 'admin' && !isMobileNavModal) {
        setShowAdminModal(true);
        return;
      }
      
      // Открываем нужную модалку с небольшой задержкой, чтобы предыдущие модалки успели закрыться
      // Используем requestAnimationFrame для гарантии, что DOM обновился перед открытием новой модалки
      requestAnimationFrame(() => {
        setTimeout(() => {
      switch (n.key) {
        case 'all-leaves':
          fetchPendingCount();
          // Устанавливаем флаг, что мы только что открыли модалку
          justOpenedGeneralCalendar.current = true;
          console.log('SidebarNav: Открываем модалку календаря, устанавливаем защиту');
          // Открываем модалку синхронно, чтобы она точно открылась
          setShowGeneralCalendar(true);
          // Сбрасываем флаг через задержку, чтобы защитить от случайного закрытия
          setTimeout(() => {
            console.log('SidebarNav: Снимаем защиту с модалки календаря');
            justOpenedGeneralCalendar.current = false;
          }, 500);
          break;
        case 'leaves':
          if (isMobile) {
            requestAnimationFrame(() => {
              setShowLeaveCalendar(true);
            });
          } else {
            requestAnimationFrame(() => {
              setShowLeaveCalendar(true);
            });
          }
          break;
        case 'news':
          if (isMobileNavModal && onCloseMobileSidebar) onCloseMobileSidebar();
          requestAnimationFrame(() => {
            setShowNewsModal(true);
          });
          dispatch({ type: 'RESET_UNREAD_NEWS' });
          fetch('/api/news', { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
            .then(r => r.json())
            .then(newsArr => {
              if (Array.isArray(newsArr) && newsArr.length > 0) {
                localStorage.setItem('lastNewsId', String(newsArr[0].id));
              }
            })
            .catch(err => console.error('Ошибка загрузки новостей:', err));
          break;
        case 'welcome':
          if (isMobileNavModal && onCloseMobileSidebar) onCloseMobileSidebar();
          requestAnimationFrame(() => {
            setShowWelcomeModal(true);
          });
          break;
        case 'tasks':
          setShowTodoModal(false);
          requestAnimationFrame(() => {
            setShowTasksModal(true);
          });
          setMyTasksCount(0);
          setTimeout(() => fetchMyTasksCount(), 300);
          break;
        case 'todo':
          setShowTasksModal(false);
          try { window.dispatchEvent(new Event('show-todo')); } catch (e) { /* ignore */ }
          requestAnimationFrame(() => {
            setShowTodoModal(true);
          });
          break;
        case 'kanban':
          requestAnimationFrame(() => {
            setShowKanbanModal(true);
          });
          break;
        case 'chats':
          if (isMobile) {
            requestAnimationFrame(() => {
              setShowChatsModal(true);
            });
          } else {
            // На десктопе по кнопке «Чаты» сразу открываем модалку сотрудников
            setShowEmployeesModal(true);
          }
          break;
        case 'employees':
          // Для обычных пользователей показываем только рейтинг, для админов/HR - полную модалку
          const userRole = appState.user?.role;
          if (userRole === 'user') {
            // Обычные пользователи видят только рейтинг
            window.dispatchEvent(new Event('show-employee-rating'));
          } else {
            // Админы и HR видят полную модалку с функциями сотрудников (список, дни рождения, календарь, рейтинг)
            if (isMobile) {
              requestAnimationFrame(() => {
                setShowBirthdaysModal(true);
              });
            } else {
              setTimeout(() => setShowBirthdaysModal(true), 0);
            }
          }
          break;
        case 'worktime':
          if (isMobile) {
            requestAnimationFrame(() => {
              setShowWorkTimeModal(true);
            });
          } else {
            setTimeout(() => setShowWorkTimeModal(true), 0);
          }
          break;
        case 'vpr':
          requestAnimationFrame(() => {
            setShowVprModal(true);
          });
          break;
        case 'orders':
          requestAnimationFrame(() => {
            setShowOrdersModal(true);
          });
          break;
        case 'leaves-worktime':
          console.log('🔘 SidebarNav: Opening leaves-worktime modal, isMobile:', isMobile, 'showLeavesWorktimeModal before:', showLeavesWorktimeModal);
          if (isMobile) {
            requestAnimationFrame(() => {
              console.log('🔘 SidebarNav: Setting showLeavesWorktimeModal to true (mobile)');
              setShowLeavesWorktimeModal(true);
            });
          } else {
            console.log('🔘 SidebarNav: Setting showLeavesWorktimeModal to true (desktop) immediately');
            setShowLeavesWorktimeModal(true);
            console.log('🔘 SidebarNav: showLeavesWorktimeModal set to true, will re-render');
          }
          break;
        case 'admin':
          if (isMobileNavModal) {
            setShowAdminModal(true);
          }
          break;
        default:
          break;
      }
        }, 100); // Увеличена задержка для гарантированного закрытия предыдущих модалок
      });
      
      // НЕ закрываем мобильный сайдбар навигации при открытии модалки - модалки открываются поверх него
      // SidebarNav остается открытым, а модалки рендерятся через порталы
    } else {
      // Для не-модалок: закрываем все модалки и сайдбар
      try { window.dispatchEvent(new Event('close-all-modals')); } catch {}
      closeAllModals();
      if (onCloseMobileSidebar) {
        onCloseMobileSidebar();
      }
      // Переключаем основной контент
      window.dispatchEvent(new CustomEvent(n.event));
    }
  };

  // Блокируем скролл body для мобильной модалки
  useEffect(() => {
    if (isMobileNavModal && isMobile && open) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [open, isMobileNavModal, isMobile]);

  // Порталы модалок для полноэкранного меню на телефоне: должны жить и при open=false,
  // иначе после закрытия меню модалки размонтируются, а флаги остаются true.
  const userRightsModalPortal = createSafePortal(
          <div 
            className="admin-user-rights-overlay"
            onClick={() => setShowUserRightsModal(false)} 
            style={{
              position: 'fixed',
              top: 0,
              left: isMobile ? 0 : 320,
              right: 0,
              bottom: 0,
              width: isMobile ? '100vw' : 'calc(100vw - 320px)',
              maxWidth: '100vw',
              height: '100vh',
              background: 'rgba(0,0,0,0.55)',
              zIndex: 1,
              pointerEvents: 'auto',
              display: 'flex',
              alignItems: 'stretch',
              justifyContent: 'flex-start',
              overflow: 'hidden',
              boxSizing: 'border-box',
            }}
          >
            <div 
              onClick={e => e.stopPropagation()} 
              style={{
                background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)',
                width: '100%',
                maxWidth: '100vw',
                height: '100%',
                overflow: 'auto',
                overflowX: 'hidden',
                WebkitOverflowScrolling: 'touch',
                display: 'flex',
                flexDirection: 'column',
                color: '#e2e8f0',
                padding: isMobile ? '12px 14px' : '24px 32px',
                boxSizing: 'border-box'
              }}
            >
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:10,gap:12,flexWrap:'wrap'}}>
                <h3 style={{margin:0,fontWeight:900,fontSize: isMobile ? '1.05rem' : '1.35em',flex:'1 1 200px',minWidth:0,lineHeight:1.25}}>Права пользователей — департаменты</h3>
                <div style={{display:'flex',alignItems:'center',gap:10,flexShrink:0}}>
                  {isHrOrDirectorRole(state.user?.role) ? (
                    <button
                      type="button"
                      onClick={() => setShowOnecMassShutdownUserRights(true)}
                      style={{
                        display:'inline-flex',
                        alignItems:'center',
                        gap:8,
                        padding:'10px 14px',
                        borderRadius:10,
                        border:'1px solid rgba(239,68,68,0.45)',
                        background:'rgba(239,68,68,0.2)',
                        color:'#fecaca',
                        cursor:'pointer',
                        fontWeight:700,
                        fontSize: isMobile ? '0.78rem' : '0.95rem',
                        whiteSpace: isMobile ? 'normal' : 'nowrap',
                        textAlign: 'left',
                        maxWidth: isMobile ? 'min(100%, 200px)' : 'none',
                      }}
                    >
                      <FiAlertTriangle size={18} /> {isMobile ? '1С: все' : 'Выбросить всех с 1С'}
                    </button>
                  ) : null}
                  <button
                    type="button"
                    onClick={() => setShowUserRightsModal(false)}
                    style={{
                      background:'transparent',
                      border:'none',
                      color:'#9ca3af',
                      cursor:'pointer',
                      fontSize:'1.5rem',
                      padding:'4px',
                      borderRadius:'4px'
                    }}
                  >
                    <FiX />
                  </button>
                </div>
              </div>
              <p style={{margin:'0 0 16px 0',color:'#94a3b8',fontSize: isMobile ? '0.88rem' : '1.05rem',lineHeight:1.45}}>
                Три поля: <b style={{color:'#e2e8f0'}}>доступ к отделам</b> (галочки — для кнопок сайдбара),{' '}
                <b style={{color:'#e2e8f0'}}>должность</b> и <b style={{color:'#e2e8f0'}}>роль</b>.
                Отдельный выбор «департамент» убран — он дублировал доступ к отделам.
              </p>
              
              {/* Быстрый поиск по ФИО */}
              <div style={{ marginBottom: 16, width: '100%', minWidth: 0 }}>
                <input
                  type="text"
                  placeholder="Поиск по ФИО..."
                  value={userRightsSearchFio}
                  onChange={e => setUserRightsSearchFio(e.target.value)}
                  style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : 320,
                    padding: '10px 14px',
                    borderRadius: 8,
                    border: '1px solid rgba(255,255,255,0.2)',
                    background: 'rgba(17,24,39,0.7)',
                    color: '#e5e7eb',
                    fontSize: '1rem',
                    outline: 'none',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
              
              {/* Заголовки колонок (только десктоп) */}
              {!isMobile && (
              <div style={{
                display:'grid',
                gridTemplateColumns: '50px minmax(180px,1.2fr) minmax(240px,1.35fr) minmax(200px,1fr) 160px 90px',
                alignItems:'center',
                gap:12,
                padding:'8px 16px',
                marginBottom:'12px',
                borderBottom:'1px solid rgba(255,255,255,0.1)',
                fontSize:'0.92rem',
                fontWeight:600,
                color:'#9ca3af',
                textTransform:'uppercase',
                letterSpacing:'0.5px'
              }}>
                <div></div>
                <div>Пользователь</div>
                <div>Доступ к отделам</div>
                <div>Должность</div>
                <div>Роль</div>
                <div>ID</div>
              </div>
              )}
              
              <div style={{flex:1, minHeight:0, minWidth:0, overflowY:'auto', overflowX:'hidden', paddingRight: isMobile ? 0 : 6}}>
                {employees.length === 0 ? (
                  <div style={{textAlign:'center', padding:'40px 20px', color:'#6b7280', fontSize:'1.05rem'}}>
                    Загрузка пользователей...
                  </div>
                ) : (() => {
                  const searchTrim = (userRightsSearchFio || '').trim().toLowerCase();
                  const filtered = !searchTrim ? employees : employees.filter(emp => {
                    const label = (emp.username || ((emp.first_name || '') + ' ' + (emp.last_name || ''))).trim().toLowerCase();
                    return label.includes(searchTrim);
                  });
                  return filtered.length === 0 ? (
                    <div style={{textAlign:'center', padding:'40px 20px', color:'#9ca3af', fontSize:'1.05rem'}}>
                      Никого не найдено по запросу «{userRightsSearchFio}»
                    </div>
                  ) : (
                  filtered.map(emp => {
                    const label = emp.username || ((emp.first_name||'') + ' ' + (emp.last_name||''));
                    const currentDept = deptMap?.[emp.id] ?? emp.department ?? '';
                    const currentPosition = positionMap?.[emp.id] ?? emp.position ?? '';
                    const currentRole = roleMap?.[emp.id] || emp.role || 'user';
                    const roleInfo = roles.find(r => r.value === currentRole) || roles[0];
                    const orgDeptSet = new Set(ORG_DEPARTMENTS.map((d) => d.toLowerCase()));
                    const accessList = departmentsAccessMap?.[emp.id] || [];
                    // Галочки = орг-отделы (+ старые значения только если уже стоят у пользователя)
                    const accessDeptOptions = buildAccessDepartmentOptions(accessList);
                    const legacyDeptNote = currentDept && !orgDeptSet.has(String(currentDept).toLowerCase())
                      ? currentDept
                      : '';
                    const orgLines = formatUserOrgLines({
                      position: currentPosition,
                      department: currentDept || resolvePrimaryOrgDepartment(accessList),
                    });
                    
                    return (
                      <div key={emp.id} style={
                        isMobile
                          ? {
                              display: 'grid',
                              gridTemplateColumns: '44px minmax(0, 1fr)',
                              columnGap: 10,
                              rowGap: 10,
                              alignItems: 'start',
                              width: '100%',
                              minWidth: 0,
                              boxSizing: 'border-box',
                              margin: '8px 0',
                              padding: '12px 12px',
                              borderRadius: 12,
                              background: 'rgba(255,255,255,0.04)',
                              border: '1px solid rgba(255,255,255,0.08)',
                              transition: 'all 0.2s ease',
                            }
                          : {
                              display: 'grid',
                              gridTemplateColumns: '50px minmax(180px,1.2fr) minmax(240px,1.35fr) minmax(200px,1fr) 160px 90px',
                              alignItems: 'start',
                              gap: 12,
                              margin: '8px 0',
                              padding: '12px 16px',
                              borderRadius: 12,
                              background: 'rgba(255,255,255,0.04)',
                              border: '1px solid rgba(255,255,255,0.08)',
                              transition: 'all 0.2s ease',
                            }
                      }>
                        <div style={{
                          width:'40px',
                          height:'40px',
                          borderRadius:'50%',
                          background: emp.avatar ? `url(${emp.avatar})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          backgroundSize: 'cover',
                          backgroundPosition: 'center',
                          display:'flex',
                          alignItems:'center',
                          justifyContent:'center',
                          color:'white',
                          fontSize:'1.2rem',
                          fontWeight:'600',
                          ...(isMobile ? { gridColumn: '1', gridRow: '1' } : {}),
                        }}>
                          {!emp.avatar && (label.charAt(0)?.toUpperCase() || 'U')}
                        </div>
                        
                        <div style={{display:'flex', flexDirection:'column', gap:2, minWidth: 0, ...(isMobile ? { gridColumn: '2', gridRow: '1' } : {})}}>
                          <span style={{fontWeight:600, color:'#e2e8f0', fontSize: isMobile ? '0.95rem' : '1.08rem', wordBreak: 'break-word'}}>{label}</span>
                          {orgLines.map((line) => (
                            <span
                              key={line}
                              title={line}
                              style={{
                                fontSize: isMobile ? '0.8rem' : '0.88rem',
                                fontWeight: 600,
                                color: '#cbd5e1',
                                lineHeight: 1.35,
                                wordBreak: 'break-word',
                                overflowWrap: 'anywhere',
                                whiteSpace: 'normal',
                              }}
                            >
                              {line}
                            </span>
                          ))}
                          <span style={{
                            fontSize:'0.98rem',
                            fontWeight:600,
                            color: roleInfo.color,
                            textTransform:'uppercase',
                            letterSpacing:'0.5px'
                          }}>
                            {roleInfo.label}
                          </span>
                        </div>
  
                        {/* Доступ к отделам — галочки (видимость сайдбара / ВПР и т.п.) */}
                        <div style={{
                          display:'flex',
                          flexDirection:'column',
                          gap:6,
                          minWidth: 0,
                          width: isMobile ? '100%' : 'auto',
                          ...(isMobile ? { gridColumn: '1 / -1', gridRow: '2' } : {}),
                        }}>
                          <div style={{
                            display:'flex',
                            flexWrap:'wrap',
                            gap:6,
                            padding:'8px 10px',
                            borderRadius:8,
                            border:'1px solid rgba(125,211,252,0.35)',
                            background:'rgba(2,6,23,0.85)',
                            maxHeight: isMobile ? '180px' : '220px',
                            overflowY:'auto',
                            maxWidth: '100%',
                            boxSizing: 'border-box',
                          }}>
                            {accessDeptOptions.map(dep => {
                              const checked = accessListIncludes(accessList, dep);
                              return (
                                <label
                                  key={dep}
                                  className="user-rights-dept-chip"
                                  style={{
                                    display:'flex',
                                    alignItems:'center',
                                    gap:6,
                                    padding:'5px 10px',
                                    borderRadius:8,
                                    background: checked ? 'rgba(16,185,129,0.35)' : 'rgba(30,41,59,0.92)',
                                    border: checked ? '1px solid rgba(52,211,153,0.95)' : '1px solid rgba(148,163,184,0.45)',
                                    fontSize: isMobile ? '0.8rem' : '0.92rem',
                                    fontWeight:600,
                                    color: '#f8fafc',
                                    WebkitTextFillColor: '#f8fafc',
                                    cursor:'pointer',
                                    whiteSpace: isMobile ? 'normal' : 'nowrap',
                                    maxWidth: '100%',
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={checked}
                                      onChange={e => {
                                      const prev = departmentsAccessMap?.[emp.id] || [];
                                      let nextList;
                                      if (e.target.checked) {
                                        nextList = accessListIncludes(prev, dep) ? prev : [...prev, dep];
                                      } else {
                                        nextList = prev.filter((x) => String(x).toLowerCase() !== String(dep).toLowerCase());
                                      }
                                      setDepartmentsAccess(emp.id, nextList);
                                    }}
                                    style={{ cursor:'pointer', accentColor:'#34d399', flexShrink: 0 }}
                                  />
                                  <span style={{ color: '#f8fafc', WebkitTextFillColor: '#f8fafc' }}>{dep}</span>
                                </label>
                              );
                            })}
                          </div>
                          {legacyDeptNote && (
                            <div style={{ fontSize: '0.72rem', color: '#94a3b8', lineHeight: 1.35 }}>
                              Старое значение для сайдбара сохранено: «{legacyDeptNote}». Отметьте нужные отделы выше — и оно перестанет быть нужным.
                            </div>
                          )}
                        </div>
  
                        <div style={{ position: 'relative', minWidth: 0, width: isMobile ? '100%' : 'auto', display: 'flex', flexDirection: 'column', ...(isMobile ? { gridColumn: '1 / -1', gridRow: '3' } : {}) }}>
                          <input
                            type="text"
                            value={currentPosition}
                            onChange={e => {
                              const val = e.target.value;
                              setPosition(emp.id, val);
                            }}
                            onFocus={() => setOpenedPositionListForUser(emp.id)}
                            onBlur={() => {
                              setTimeout(() => {
                                setOpenedPositionListForUser((prev) => (prev === emp.id ? null : prev));
                              }, 120);
                            }}
                            placeholder="Выберите или введите должность"
                            style={{
                              width: '100%',
                              maxWidth: '100%',
                              minWidth: 0,
                              padding: '8px 12px',
                              borderRadius: 6,
                              border: '1px solid rgba(255,255,255,0.16)',
                              background: 'rgba(17,24,39,0.65)',
                              color: '#e5e7eb',
                              fontSize: isMobile ? '0.88rem' : '1rem',
                              outline: 'none',
                              boxSizing: 'border-box'
                            }}
                          />
                          {openedPositionListForUser === emp.id && (
                            <div
                              onMouseDown={(e) => e.preventDefault()}
                              style={{
                                position: 'absolute',
                                top: 'calc(100% + 6px)',
                                left: 0,
                                width: isMobile ? '100%' : 320,
                                minWidth: isMobile ? 0 : 320,
                                maxWidth: isMobile ? '100%' : 'calc(100vw - 80px)',
                                boxSizing: 'border-box',
                                border: '1px solid rgba(148,163,184,0.35)',
                                borderRadius: 8,
                                background: '#525660',
                                maxHeight: 800,
                                overflowY: 'auto',
                                padding: 6,
                                zIndex: 30,
                                boxShadow: '0 12px 24px rgba(0,0,0,0.45)',
                              }}
                            >
                              {positions.map((pos) => (
                                <div
                                  key={pos}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = '#3553d7';
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = 'transparent';
                                  }}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 8,
                                    padding: '6px 8px',
                                    borderRadius: 6,
                                    background: 'transparent',
                                    transition: 'background 0.15s ease',
                                  }}
                                >
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setPosition(emp.id, pos);
                                      setOpenedPositionListForUser(null);
                                    }}
                                    style={{
                                      flex: 1,
                                      textAlign: 'left',
                                      background: 'transparent',
                                      border: 'none',
                                      color: '#e5e7eb',
                                      cursor: 'pointer',
                                      padding: 0,
                                      fontSize: isMobile ? '1rem' : '1.1rem',
                                    }}
                                  >
                                    {pos}
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => handleDeletePosition(pos)}
                                    title="Удалить должность"
                                    onMouseEnter={(e) => {
                                      e.currentTarget.style.background = 'rgba(239,68,68,0.28)';
                                      e.currentTarget.style.borderColor = 'rgba(239,68,68,0.85)';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.currentTarget.style.background = 'rgba(239,68,68,0.15)';
                                      e.currentTarget.style.borderColor = 'rgba(239,68,68,0.55)';
                                    }}
                                    style={{
                                      width: 22,
                                      height: 22,
                                      borderRadius: 999,
                                      border: '1px solid rgba(239,68,68,0.55)',
                                      background: 'rgba(239,68,68,0.15)',
                                      color: '#fca5a5',
                                      cursor: 'pointer',
                                      lineHeight: 1,
                                      fontWeight: 700,
                                    }}
                                  >
                                    ×
                                  </button>
                                </div>
                              ))}
                            </div>
                          )}
                          <div style={{ display: 'flex', gap: 8, marginTop: 8, flexDirection: 'column', minWidth: 0 }}>
                            <input
                              type="text"
                              value={newPositionInput}
                              onChange={(e) => setNewPositionInput(e.target.value)}
                              placeholder="Новая должность"
                              style={{
                                flex: 1,
                                width: '100%',
                                minWidth: 0,
                                padding: '8px 10px',
                                borderRadius: 6,
                                border: '1px solid rgba(255,255,255,0.16)',
                                background: 'rgba(17,24,39,0.65)',
                                color: '#e5e7eb',
                                fontSize: isMobile ? '0.88rem' : '0.95rem',
                                outline: 'none',
                                boxSizing: 'border-box'
                              }}
                            />
                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                              <button
                                type="button"
                                onClick={handleAddPosition}
                                style={{
                                  padding: '6px 10px',
                                  borderRadius: 6,
                                  border: '1px solid rgba(16, 185, 129, 0.45)',
                                  background: 'rgba(16, 185, 129, 0.18)',
                                  color: '#d1fae5',
                                  fontSize: isMobile ? '0.88rem' : '0.9rem',
                                  fontWeight: 700,
                                  cursor: 'pointer'
                                }}
                              >
                                Добавить
                              </button>
                              <button
                                type="button"
                                onClick={() => setPosition(emp.id, '')}
                                disabled={!normalizePosition(currentPosition)}
                                style={{
                                  padding: '6px 10px',
                                  borderRadius: 6,
                                  border: '1px solid rgba(239, 68, 68, 0.45)',
                                  background: normalizePosition(currentPosition) ? 'rgba(239, 68, 68, 0.18)' : 'rgba(75, 85, 99, 0.25)',
                                  color: normalizePosition(currentPosition) ? '#fecaca' : '#9ca3af',
                                  fontSize: isMobile ? '0.88rem' : '0.9rem',
                                  fontWeight: 700,
                                  cursor: normalizePosition(currentPosition) ? 'pointer' : 'not-allowed'
                                }}
                              >
                                Очистить
                              </button>
                            </div>
                          </div>
                        </div>
                        
                        <select 
                          value={currentRole} 
                          onChange={e => {
                            const val = e.target.value;
                            setUserRole(emp.id, val);
                          }} 
                          style={{
                            padding:'8px 12px',
                            borderRadius:6,
                            border:'1px solid rgba(255,255,255,0.16)',
                            background:'rgba(17,24,39,0.65)',
                            color:'#e5e7eb',
                            fontSize: isMobile ? '0.88rem' : '1rem',
                            width: isMobile ? '100%' : 'auto',
                            maxWidth: '100%',
                            minWidth: 0,
                            boxSizing: 'border-box',
                            ...(isMobile ? { gridColumn: '1 / -1', gridRow: '4' } : {}),
                          }}
                        >
                          {roles.map(role => (
                            <option key={role.value} value={role.value}>{role.label}</option>
                          ))}
                        </select>
                        
                        <div style={{
                          textAlign: isMobile ? 'left' : 'center',
                          fontSize:'0.98rem',
                          color:'#6b7280',
                          ...(isMobile ? { gridColumn: '1 / -1', gridRow: '5' } : {}),
                        }}>
                          ID: {emp.id}
                        </div>
                      </div>
                    );
                  })
                  );
                }
              )()}
              </div>
            </div>
          </div>,
          showUserRightsModal,
          { useNestedModalRoot: true },
  );

  const mobileSidebarNavModalPortals = (
    <>
        {createSafePortal(
          isMobile ? (
            <UploadModalMobile
              key={`upload-mobile-${portalKey}`}
              open={showUploadModal}
              onClose={() => setShowUploadModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <UploadModal key={`upload-${portalKey}`} open={showUploadModal} onClose={() => setShowUploadModal(false)} />
          ),
          showUploadModal
        )}
        {createSafePortal(
          isMobile ? (
            <AllLeavesCalendarMobile key={`all-leaves-mobile-${portalKey}`} open={showGeneralCalendar} onClose={()=>setShowGeneralCalendarSafe(false)} token={localStorage.getItem('token')} onOpenMobileSidebar={onOpenMobileSidebar} />
          ) : (
            <AllLeavesCalendar key={`all-leaves-${portalKey}`} open={showGeneralCalendar} onClose={()=>setShowGeneralCalendarSafe(false)} token={localStorage.getItem('token')} />
          ),
          showGeneralCalendar
        )}
        {createSafePortal(
          isMobile ? (
            <LeavesMobile
              key={`leaves-mobile-${portalKey}`}
              open={showLeaveCalendar}
              onClose={()=>setShowLeaveCalendar(false)}
              token={localStorage.getItem('token')}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <LeaveCalendarModal key={`leave-${portalKey}`} open={showLeaveCalendar} onClose={()=>setShowLeaveCalendar(false)} leaves={[]} />
          ),
          showLeaveCalendar
        )}
        {showOrdersModal && ReactDOM.createPortal(
          <WarehouseOrdersModal key={`orders-mobile-${portalKey}`} isOpen onRequestClose={() => setShowOrdersModal(false)} />,
          document.body
        )}
        {isMobile && createSafePortal(
          <ChatsListModalMobile
            key={`chats-mobile-${portalKey}`}
            open={showChatsModal}
            onClose={()=>setShowChatsModal(false)}
            onOpenMobileSidebar={onOpenMobileSidebar}
            onOpenChat={() => {
              setShowChatsModal(false);
              setShowChatAreaModal(true);
            }}
            onOpenCreateChat={() => {
              setShowChatsModal(false);
              setShowCreateChatModal(true);
            }}
          />,
          showChatsModal
        )}
        {isMobile && createSafePortal(
          <CreateChatModalMobile
            key={`create-chat-mobile-${portalKey}`}
            open={showCreateChatModal}
            onClose={() => setShowCreateChatModal(false)}
            onOpenChatsList={() => {
              setShowCreateChatModal(false);
              setShowChatsModal(true);
            }}
          />,
          showCreateChatModal
        )}
        {createSafePortal(
          isMobile ? (
            <ChatAreaMobile
              key={`chat-area-mobile-${portalKey}`}
              open={showChatAreaModal}
              onClose={()=>setShowChatAreaModal(false)}
              onOpenChatsList={() => {
                setShowChatAreaModal(false);
                setShowChatsModal(true);
              }}
            />
          ) : null,
          showChatAreaModal && isMobile
        )}
        {createSafePortal(
          showWelcomeModal && (
            <div
              style={{
                position: 'fixed',
                inset: 0,
                zIndex: 100003,
                pointerEvents: 'auto',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                paddingTop: isMobile ? 'max(8px, env(safe-area-inset-top, 0px))' : undefined,
                paddingBottom: isMobile ? 'max(0px, env(safe-area-inset-bottom, 0px))' : undefined,
                ...welcomeScreenFillStyle(welcomeModalAppTitleSettings),
                overflow: 'hidden',
              }}
              onClick={(e) => e.target === e.currentTarget && setShowWelcomeModal(false)}
            >
              <WelcomeScreenPhotoBackground
                imageUrl={
                  welcomeModalAppTitleSettings?.welcomeScreenBackgroundType === 'image'
                    ? welcomeModalAppTitleSettings.welcomeScreenBackgroundImage
                    : null
                }
              />
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setShowWelcomeModal(false); }}
                style={{
                  position: 'fixed',
                  top: isMobile ? 'max(12px, env(safe-area-inset-top, 12px))' : 16,
                  right: isMobile ? 'max(12px, env(safe-area-inset-right, 12px))' : 16,
                  zIndex: 100005,
                  padding: isMobile ? '10px 14px' : '12px 20px',
                  borderRadius: 12,
                  border: '2px solid rgba(255,255,255,0.5)',
                  background: 'rgba(30, 58, 95, 0.95)',
                  color: '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  fontSize: isMobile ? '0.9rem' : '1rem',
                  fontWeight: 700,
                  boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
                  touchAction: 'manipulation',
                }}
                aria-label="Закрыть"
              >
                <FiX size={isMobile ? 20 : 22} />
                Закрыть
              </button>
              {!isMobile && (
              <button
                type="button"
                onClick={(e) => { e.stopPropagation(); setShowWelcomeModal(false); }}
                style={{
                  position: 'fixed',
                  bottom: 24,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 100004,
                  padding: '14px 28px',
                  borderRadius: 12,
                  border: '2px solid rgba(255,255,255,0.5)',
                  background: '#1e3a5f',
                  color: '#fff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  fontSize: '1.05rem',
                  fontWeight: 700,
                  boxShadow: '0 4px 24px rgba(0,0,0,0.5)',
                }}
                aria-label="Закрыть"
              >
                <FiX size={22} />
                Закрыть
              </button>
              )}
              <div
                style={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  flex: isMobile ? 1 : undefined,
                  minHeight: 0,
                  zIndex: 100002,
                  display: 'flex',
                  flexDirection: 'column',
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <WelcomeScreenHero appTitleSettings={welcomeModalAppTitleSettings} />
              </div>
            </div>
          ),
          showWelcomeModal
        )}
        {createSafePortal(
          isMobile ? (
            <NewsMobile
              key={`news-mobile-${portalKey}`}
              open={showNewsModal}
              onClose={() => { setShowNewsModal(false); setNewsModalInitialAdd(false); setNewsModalInitialPoll(false); }}
              onOpenMobileSidebar={onOpenMobileSidebar}
              initialOpenAddModal={newsModalInitialAdd}
              initialOpenPollModal={newsModalInitialPoll}
              onConsumeInitialOpen={() => { setNewsModalInitialAdd(false); setNewsModalInitialPoll(false); }}
            />
          ) : (
            <NewsModal
              key={`news-${portalKey}`}
              open={showNewsModal}
              onClose={() => { setShowNewsModal(false); setNewsModalInitialAdd(false); setNewsModalInitialPoll(false); }}
              initialOpenAddModal={newsModalInitialAdd}
              initialOpenPollModal={newsModalInitialPoll}
              onConsumeInitialOpen={() => { setNewsModalInitialAdd(false); setNewsModalInitialPoll(false); }}
            />
          ),
          showNewsModal
        )}
        {createSafePortal(
          isMobile ? (
            <TasksMobile
              key={`tasks-mobile-${portalKey}`}
              open={showTasksModal}
              onClose={() => { setShowTasksModal(false); setVprCreateTaskFile(null); }}
              onOpenMobileSidebar={onOpenMobileSidebar}
              initialFileForCreate={vprCreateTaskFile}
              onConsumedInitialFile={() => setVprCreateTaskFile(null)}
            />
          ) : (
            <TasksModal key={`tasks-${portalKey}`} open={showTasksModal} onClose={() => { setShowTasksModal(false); setVprCreateTaskFile(null); }} initialFileForCreate={vprCreateTaskFile} onConsumedInitialFile={() => setVprCreateTaskFile(null)} />
          ),
          showTasksModal
        )}
        {createSafePortal(
          isMobile ? (
            <TodoMobile
              key={`todo-mobile-${portalKey}`}
              open={showTodoModal}
              onClose={() => setShowTodoModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <TodoModal key={`todo-${portalKey}`} open={showTodoModal} onClose={() => setShowTodoModal(false)} />
          ),
          showTodoModal
        )}
        {createSafePortal(
          <KanbanModal
            key={`kanban-${portalKey}`}
            open={showKanbanModal}
            onClose={() => setShowKanbanModal(false)}
            isMobile={isMobile}
          />,
          showKanbanModal
        )}
        {createSafePortal(
          isMobile ? (
            <WorkTimeMobile
              key={`worktime-mobile-${portalKey}`}
              open={showWorkTimeModal}
              onClose={() => setShowWorkTimeModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <WorkTimeReportModal key={`worktime-${portalKey}`} isOpen={showWorkTimeModal} onRequestClose={() => setShowWorkTimeModal(false)} />
          ),
          showWorkTimeModal
        )}
        {createSafePortal(
          <VprModal key={`vpr-${portalKey}`} isOpen={showVprModal} onRequestClose={() => setShowVprModal(false)} isMobile={isMobile} />,
          showVprModal
        )}
        {(() => {
          const modalComponent = isMobile ? (
            <LeavesWorktimeMobile
              key={`leaves-worktime-mobile-${portalKey}`}
              open={showLeavesWorktimeModal}
              onClose={() => {
                setShowLeavesWorktimeModal(false);
              }}
              token={localStorage.getItem('token')}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <LeavesWorktimeModal
              key={`leaves-worktime-${portalKey}`}
              isOpen={showLeavesWorktimeModal}
              onRequestClose={() => {
                setShowLeavesWorktimeModal(false);
                setInitialWorktimeFilter(null);
              }}
              token={localStorage.getItem('token')}
              initialFilter={initialWorktimeFilter}
              onInitialFilterConsumed={() => setInitialWorktimeFilter(null)}
            />
          );
          return createSafePortal(modalComponent, showLeavesWorktimeModal);
        })()}
        {createSafePortal(
          isMobile ? (
            <CongratulationsMobile
              key={`birthdays-mobile-${portalKey}`}
              open={showBirthdaysModal}
              onClose={() => setShowBirthdaysModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <CongratulationsModal key={`birthdays-${portalKey}`} open={showBirthdaysModal} onClose={() => setShowBirthdaysModal(false)} />
          ),
          showBirthdaysModal
        )}
        {createSafePortal(
          isMobile ? (
            <EmployeesMobile
              key={`employees-mobile-${portalKey}`}
              open={showEmployeesModal}
              onClose={() => setShowEmployeesModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
              onOpenUserRights={() => setShowUserRightsModal(true)}
            />
          ) : (
            <EmployeesListModal
              key={`employees-${portalKey}`}
              open={showEmployeesModal}
              onClose={() => setShowEmployeesModal(false)}
              isMobile={isMobile}
              onOpenUserRights={() => setShowUserRightsModal(true)}
            />
          ),
          showEmployeesModal
        )}
        {isMobileNavModal &&
          createSafePortal(
            <AdminMobile
              key={`admin-mobile-${portalKey}`}
              open={showAdminModal}
              onClose={() => setShowAdminModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
              onOpenEmojiSettings={() => setShowEmojiSettingsModal(true)}
              onOpenTemplates={() => setShowTemplatesModal(true)}
              onOpenAppTitleSettings={() => setShowAppTitleSettingsModal(true)}
            />,
            showAdminModal
          )}
        {createSafePortal(
          isMobile ? (
            <EmojiSettingsMobile
              key={`emoji-settings-mobile-${portalKey}`}
              open={showEmojiSettingsModal}
              onClose={() => setShowEmojiSettingsModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <EmojiSettingsModal key={`emoji-settings-${portalKey}`} open={showEmojiSettingsModal} onClose={() => setShowEmojiSettingsModal(false)} />
          ),
          showEmojiSettingsModal
        )}
        {createSafePortal(
          isMobile ? (
            <TemplatesManagementMobile
              key={`templates-mobile-${portalKey}`}
              open={showTemplatesModal}
              onClose={() => setShowTemplatesModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <TemplatesManagementModal key={`templates-${portalKey}`} isOpen={showTemplatesModal} onClose={() => setShowTemplatesModal(false)} />
          ),
          showTemplatesModal
        )}
        {createSafePortal(
          <AppTitleSettingsModal
            key={`app-title-settings-${portalKey}`}
            open={showAppTitleSettingsModal}
            onClose={() => setShowAppTitleSettingsModal(false)}
          />,
          showAppTitleSettingsModal
        )}
        {createSafePortal(
          isMobile ? (
            <RatingMobile
              key={`rating-mobile-${portalKey}`}
              open={showRatingModal}
              onClose={() => setShowRatingModal(false)}
              onOpenMobileSidebar={onOpenMobileSidebar}
            />
          ) : (
            <EmployeeRatingModal key={`rating-${portalKey}`} isOpen={showRatingModal} onClose={() => setShowRatingModal(false)} />
          ),
          showRatingModal
        )}
        {userRightsModalPortal}
    </>
  );

  const renderNavButton = (n, extraStyle) => (
    <button
      key={n.key}
      type="button"
      className={active === n.key ? 'nd-navIt nd-on' : 'nd-navIt'}
      style={extraStyle}
      title={n.tip}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleNavClick(n); }}
    >
      <span className="nd-ic">{n.emoji || n.icon}</span>
      {n.label}
      {n.key === 'all-leaves' && pendingCount > 0 && (
        <span className="nd-nBadge">{pendingCount}</span>
      )}
      {n.key === 'tasks' && myTasksCount > 0 && (
        <span className="nd-nBadge">{myTasksCount}</span>
      )}
      {n.key === 'news' && state.unreadNews > 0 && (
        <span className="nd-nBadge nd-red">{state.unreadNews}</span>
      )}
      {n.key === 'chats' && state.unreadChats > 0 && (
        <span className="nd-nBadge">{state.unreadChats}</span>
      )}
    </button>
  );

  const renderNavGroups = ({ waitUntilVisibilityLoaded = false, extraBtnStyle } = {}) => (
    NAV_SECTIONS.map((sec) => {
      const items = sec.keys
        .map((k) => NAV_BY_KEY[k])
        .filter((n) => n && isSidebarNavVisible(n, {
          user: state.user,
          sidebarVisibility,
          sidebarVisibilityLoaded,
          showKanbanButton,
          showLeavesWorktimeButton,
          waitUntilVisibilityLoaded,
        }));
      if (!items.length) return null;
      return (
        <div key={sec.id} className="nd-navGroup">
          {sec.title ? <div className="nd-navSec">{sec.title}</div> : null}
          {items.map((n) => renderNavButton(n, extraBtnStyle))}
        </div>
      );
    })
  );

  // Если это мобильная навигация как модалка
  if (isMobileNavModal && isMobile) {
    if (!open) return <>{mobileSidebarNavModalPortals}</>;

    const navContent = (
      <>
        <div
          className="nd-mobileNavOverlay"
          style={{ pointerEvents: 'auto' }}
          onClick={onCloseMobileSidebar}
        >
          <div className="nd-mobileNavPanel" onClick={e => e.stopPropagation()}>
            <div className="nd-mobileNavHead">
              <button
                type="button"
                className="nd-burger"
                title="Открыть меню"
                onClick={(e) => {
                  e.stopPropagation();
                  if (onOpenMobileSidebar) {
                    onOpenMobileSidebar();
                  }
                }}
              >
                <FaBars />
              </button>

              <div className="nd-logoIco">💬</div>

              {!hideTitle && (
                <div className="nd-logoT" style={{ flex: 1 }}>
                  <b>{appTitleSettings.subtitleText || 'Мульти - мессенджер'}</b>
                  <span className="nd-brand">{appTitleSettings.text || 'Issa Plus'}</span>
                </div>
              )}

              <button
                type="button"
                className="nd-themeBtn"
                title={ndIsLight ? 'Тёмная тема' : 'Светлая тема'}
                onClick={(e) => { e.stopPropagation(); toggleNdTheme(); }}
              >
                {ndIsLight ? <FiMoon /> : <FiSun />}
              </button>

            {/* Старая неоновая вывеска отключена новым дизайном */}
            {false && <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flex: 1,
                margin: '0 auto',
                maxWidth: 'fit-content',
                gap: '4px',
                position: 'relative'
              }}>
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                  fontSize: appTitleSettings.subtitleFontSize || '1.18em',
                  fontWeight: 700,
                  letterSpacing: '0.01em',
                  color: appTitleSettings.subtitleColor || '#fff',
                  position: 'relative',
                  left: `${appTitleSettings.subtitlePositionX || 0}px`,
                  top: `${appTitleSettings.subtitlePositionY || 0}px`
                }}>
                  <span role="img" aria-label="chat">💬</span> {appTitleSettings.subtitleText || 'Мульти - мессенджер'}
                </span>
                <span className="neon-issa-plus issa-plus-festive" style={(() => {
                  const style = {
                    fontSize: appTitleSettings.fontSize || '2em',
                    fontFamily: appTitleSettings.customFontName ? `"${appTitleSettings.customFontName}", ${appTitleSettings.fontFamily}` : appTitleSettings.fontFamily,
                    marginTop: 2,
                  };

                  // Применяем градиент (если не используется градиентная анимация)
                  const effectType = appTitleSettings.effectType || 'neon';
                  if (appTitleSettings.useGradient === true && effectType !== 'gradient-animation') {
                    const gradientStart = appTitleSettings.gradientStart || '#43e97b';
                    const gradientEnd = appTitleSettings.gradientEnd || '#2193b0';
                    style.background = `linear-gradient(135deg, ${gradientStart} 0%, ${gradientEnd} 100%)`;
                    style.WebkitBackgroundClip = 'text';
                    style.WebkitTextFillColor = 'transparent';
                    style.backgroundClip = 'text';
                    style.color = 'transparent';
                  } else if (effectType === 'gradient-animation' && appTitleSettings.glowEnabled) {
                    style.color = 'transparent';
                  } else {
                    style.color = appTitleSettings.color || '#43e97b';
                    style.background = 'none';
                    style.WebkitBackgroundClip = 'unset';
                    style.WebkitTextFillColor = 'unset';
                    style.backgroundClip = 'unset';
                  }
                  
                  // Убеждаемся, что текст всегда виден
                  style.display = 'inline-block';
                  style.visibility = 'visible';

                  // Применяем эффекты в зависимости от выбранного типа
                  if (appTitleSettings.glowEnabled === true) {
                    const intensity = Number(appTitleSettings.glowIntensity);
                    const spread = Number(appTitleSettings.glowSpread);
                    const glowColor = appTitleSettings.glowColor || '#43e97b';
                    
                    const finalIntensity = (isNaN(intensity) || intensity === 0) ? 12 : intensity;
                    const finalSpread = (isNaN(spread) || spread === 0) ? 32 : spread;
                    
                    switch (effectType) {
                      case 'shadow':
                        style.textShadow = `3px 3px 6px rgba(0,0,0,0.5), 0 0 ${finalIntensity}px ${glowColor}, 0 0 ${finalSpread}px ${glowColor}`;
                        break;
                      case 'outline':
                        style.textShadow = `-1px -1px 0 ${glowColor}, 1px -1px 0 ${glowColor}, -1px 1px 0 ${glowColor}, 1px 1px 0 ${glowColor}, 0 0 ${finalIntensity}px ${glowColor}, 0 0 ${finalSpread}px ${glowColor}`;
                        break;
                      case 'sparkle':
                        style.textShadow = `0 0 ${finalIntensity}px ${glowColor}, 0 0 ${finalSpread}px ${glowColor}, 0 0 ${finalSpread * 1.5}px ${glowColor}, 2px 2px 4px rgba(0,0,0,0.3), -2px -2px 4px ${glowColor}88`;
                        break;
                      case 'gradient-animation':
                        style.textShadow = `0 0 ${finalIntensity}px ${glowColor}, 0 0 ${finalSpread}px ${glowColor}`;
                        break;
                      case 'new-year':
                        break;
                      case 'neon':
                      default:
                        break;
                    }
                  } else {
                    style.textShadow = 'none';
                  }

                  return {
                    ...style,
                    position: 'relative',
                    left: `${appTitleSettings.textPositionX || 0}px`,
                    top: `${appTitleSettings.textPositionY || 0}px`
                  };
                })()}>
                  <span className="issa-plus-text">
                    <span className="issa-plus-word">
                      {appTitleSettings.text || 'Issa Plus'}
                      {isWinterSeason && (
                        <span className="issa-plus-last">
                          <span className="santa-hat">
                            <span className="santa-hat__pom" />
                          </span>
                        </span>
                      )}
                    </span>
                  </span>
                </span>
              </div>}
              
              <style>{`
                @keyframes neonGlow {
                  0% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${((Number(appTitleSettings.glowSpread) || 32) * 0.5)}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 2px #fff, 
                                0 0 ${((Number(appTitleSettings.glowSpread) || 32) * 0.75)}px ${appTitleSettings.glowColor || '#43e97b'}88; 
                  }
                  50% { 
                    text-shadow: 0 0 ${((Number(appTitleSettings.glowIntensity) || 12) * 2)}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 8px #fff, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}cc; 
                  }
                  100% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${((Number(appTitleSettings.glowSpread) || 32) * 0.5)}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 2px #fff, 
                                0 0 ${((Number(appTitleSettings.glowSpread) || 32) * 0.75)}px ${appTitleSettings.glowColor || '#43e97b'}88; 
                  }
                }
                @keyframes gradientAnimation {
                  0% { 
                    background-position: 0% 50%;
                  }
                  50% { 
                    background-position: 100% 50%;
                  }
                  100% { 
                    background-position: 0% 50%;
                  }
                }
                @keyframes sparkleAnimation {
                  0%, 100% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                2px 2px 4px rgba(0,0,0,0.3),
                                -2px -2px 4px ${appTitleSettings.glowColor || '#43e97b'}88;
                  }
                  25% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                4px 4px 8px rgba(0,0,0,0.3),
                                -4px -4px 8px ${appTitleSettings.glowColor || '#43e97b'}cc,
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 1.5}px ${appTitleSettings.glowColor || '#43e97b'};
                  }
                  50% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                2px 2px 4px rgba(0,0,0,0.3),
                                -2px -2px 4px ${appTitleSettings.glowColor || '#43e97b'}88;
                  }
                  75% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px ${appTitleSettings.glowColor || '#43e97b'}, 
                                -4px -4px 8px rgba(0,0,0,0.3),
                                4px 4px 8px ${appTitleSettings.glowColor || '#43e97b'}cc,
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 1.5}px ${appTitleSettings.glowColor || '#43e97b'};
                  }
                }
                @keyframes newYearAnimation {
                  0% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px #ff0000, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px #ff0000, 
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 0.5}px #ffd700,
                                2px 2px 4px rgba(255, 0, 0, 0.5);
                    filter: hue-rotate(0deg);
                  }
                  25% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px #00ff00, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px #00ff00, 
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 0.5}px #ffd700,
                                2px 2px 4px rgba(0, 255, 0, 0.5);
                    filter: hue-rotate(90deg);
                  }
                  50% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px #ffd700, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px #ffd700, 
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 0.5}px #ff0000,
                                2px 2px 4px rgba(255, 215, 0, 0.5);
                    filter: hue-rotate(180deg);
                  }
                  75% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px #ff1493, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px #ff1493, 
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 0.5}px #00ff00,
                                2px 2px 4px rgba(255, 20, 147, 0.5);
                    filter: hue-rotate(270deg);
                  }
                  100% { 
                    text-shadow: 0 0 ${Number(appTitleSettings.glowIntensity) || 12}px #ff0000, 
                                0 0 ${Number(appTitleSettings.glowSpread) || 32}px #ff0000, 
                                0 0 ${(Number(appTitleSettings.glowSpread) || 32) * 0.5}px #ffd700,
                                2px 2px 4px rgba(255, 0, 0, 0.5);
                    filter: hue-rotate(360deg);
                  }
                }
                .neon-issa-plus {
                  display: inline;
                  white-space: nowrap;
                  ${(appTitleSettings.glowEnabled === true && (appTitleSettings.effectType || 'neon') === 'neon') ? 'animation: neonGlow 1.6s infinite alternate;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? 'animation: gradientAnimation 3s ease infinite;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? `background: linear-gradient(-45deg, ${appTitleSettings.glowColor || '#43e97b'}, ${appTitleSettings.color || '#43e97b'}, ${appTitleSettings.glowColor || '#43e97b'}, ${appTitleSettings.color || '#43e97b'});` : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? 'background-size: 400% 400%;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? '-webkit-background-clip: text;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? '-webkit-text-fill-color: transparent;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'gradient-animation') ? 'background-clip: text;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'sparkle') ? 'animation: sparkleAnimation 2s ease-in-out infinite;' : ''}
                  ${(appTitleSettings.glowEnabled === true && appTitleSettings.effectType === 'new-year') ? 'animation: newYearAnimation 3s ease-in-out infinite;' : ''}
                }
                .issa-plus-festive {
                  position: relative;
                }
                .issa-plus-text {
                  position: relative;
                  display: inline-flex;
                  align-items: center;
                  gap: 10px;
                }
                .issa-plus-word {
                  position: relative;
                  display: inline-flex;
                  align-items: flex-start;
                  gap: 2px;
                  white-space: nowrap;
                }
                .issa-plus-last {
                  position: relative;
                  display: inline-block;
                  padding-right: 2px;
                }
                .santa-hat {
                  position: absolute;
                  top: -12px;
                  left: -4px;
                  width: 24px;
                  height: 20px;
                  background: #ff0000;
                  border-radius: 50% 50% 0 0;
                  transform: rotate(-15deg);
                }
                .santa-hat::before {
                  content: '';
                  position: absolute;
                  top: -8px;
                  left: 8px;
                  width: 8px;
                  height: 8px;
                  background: #fff;
                  border-radius: 50%;
                }
                .santa-hat__pom {
                  position: absolute;
                  top: -10px;
                  left: 10px;
                  width: 6px;
                  height: 6px;
                  background: #fff;
                  border-radius: 50%;
                }
              `}</style>
            </div>

            <div className="nd-mobileNavBody">
              <div className="nd-userCard">
                <div className="nd-uAv">
                  {ndAvatarSrc ? <img src={ndAvatarSrc} alt="avatar" /> : ndUserInitials}
                </div>
                <div className="nd-uT">
                  <b>{state.user?.username || 'Пользователь'}</b>
                  {formatUserOrgLines(state.user).map((line) => (
                    <span key={line} className="nd-uOrg" title={line}>{line}</span>
                  ))}
                </div>
                <span className="nd-uSt" title="Соединение с сервером активно" />
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {!canRenderNav ? null : renderNavGroups({ waitUntilVisibilityLoaded: true, extraBtnStyle: { pointerEvents: 'auto', touchAction: 'manipulation' } })}
              </div>
              <SidebarUploadButton onClick={() => setShowUploadModal(true)} />
            </div>
          </div>
        </div>

        {mobileSidebarNavModalPortals}
      </>
    );

    return ReactDOM.createPortal(navContent, document.body);
  }

  // Обычный рендер (для десктопа или встроенного в SidebarMobile)
  return (
    <>
      <nav className="nd-nav">
        {renderNavGroups({ extraBtnStyle: { justifyContent: ({ left: 'flex-start', center: 'center', right: 'flex-end' }[sidebarTextAlign] || 'flex-start') } })}
      </nav>
      <SidebarUploadButton onClick={() => setShowUploadModal(true)} />

      {mobileSidebarNavModalPortals}

      {!isMobileNavModal &&
        showAdminModal &&
        createSafePortal(
          <AdminDesktop
            key={`admin-desktop-${portalKey}`}
            open={showAdminModal}
            onClose={() => setShowAdminModal(false)}
          />,
          showAdminModal
        )}

      {/* Модалка редактирования пользователя - только для десктопа */}
      {!isMobile && createSafePortal(
        editRow && (
          <div style={{position:'fixed', inset:0, zIndex:200003, display:'flex', alignItems:'center', justifyContent:'center'}}>
            <div onClick={()=>setEditRow(null)} style={{position:'absolute', inset:0, background:'rgba(0,0,0,0.75)'}} />
            <div style={{position:'relative', width:'min(720px, 96vw)', background:'linear-gradient(135deg, #232931 0%, #181c22 100%)', borderRadius:20, padding:20, boxShadow:'0 10px 40px rgba(0,0,0,0.4)', color:'#fff'}} onClick={e=>e.stopPropagation()}>
              <button onClick={()=>setEditRow(null)} style={{position:'absolute', top:10, right:10, background:'transparent', border:'none', color:'#fff', fontSize:24, cursor:'pointer'}}>×</button>
              <h3 style={{marginTop:0, marginBottom:14, fontWeight:900}}>Изменить пользователя</h3>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:12}}>
                <div>
                  <label style={{display:'block', fontSize:12, color:'#9ca3af', marginBottom:6}}>Новое имя</label>
                  <input value={editRow.name} onChange={e=>setEditRow({...editRow, name:e.target.value})} style={{width:'100%', padding:12, borderRadius:10, border:'1px solid #2f3440', background:'#0e1420', color:'#fff'}} />
                </div>
                <div>
                  <label style={{display:'block', fontSize:12, color:'#9ca3af', marginBottom:6}}>Описание</label>
                  <input value={editRow.description} onChange={e=>setEditRow({...editRow, description:e.target.value})} style={{width:'100%', padding:12, borderRadius:10, border:'1px solid #2f3440', background:'#0e1420', color:'#fff'}} />
                </div>
              </div>
              <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginTop:10}}>
                <div>
                  <label style={{display:'block', fontSize:12, color:'#9ca3af', marginBottom:6}}>Новый пароль (по желанию)</label>
                  <input type="text" value={editRow.password || ''} onChange={e=>setEditRow({...editRow, password:e.target.value})} style={{width:'100%', padding:12, borderRadius:10, border:'1px solid #2f3440', background:'#0e1420', color:'#fff'}} />
                </div>
                <div>
                  <label style={{display:'block', fontSize:12, color:'#9ca3af', marginBottom:6}}>Членство в RDP</label>
                  <div style={{display:'flex', gap:8}}>
                    <button onClick={async()=>{ try { const t = localStorage.getItem('token'); await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}/rdp`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${t}` }, body: JSON.stringify({ add: true }) }); alert('Добавлен в RDP'); } catch(e){ alert('Ошибка: '+e.message); } }} style={{padding:'8px 12px', borderRadius:8, border:'1px solid #334155', background:'#0f172a', color:'#b2ffb2', cursor:'pointer'}}>Добавить</button>
                    <button onClick={async()=>{ try { const t = localStorage.getItem('token'); await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}/rdp`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${t}` }, body: JSON.stringify({ add: false }) }); alert('Убран из RDP'); } catch(e){ alert('Ошибка: '+e.message); } }} style={{padding:'8px 12px', borderRadius:8, border:'1px solid #334155', background:'#0f172a', color:'#fecaca', cursor:'pointer'}}>Убрать</button>
                  </div>
                </div>
              </div>
              <div style={{display:'flex', alignItems:'center', gap:10, color:'#ddd', marginTop:10}}>
                <label style={{display:'flex', alignItems:'center', gap:8}}>
                  <input type="checkbox" checked={!!editRow.noExpire} onChange={e=>setEditRow({...editRow, noExpire:e.target.checked})} /> Пароль не истекает
                </label>
                <button
                  onClick={async ()=>{
                    try {
                      const token = localStorage.getItem('token');
                      await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}/no-expire`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, body: JSON.stringify({ noExpire: true }) });
                      alert('Флаг «пароль не истекает» установлен');
                    } catch(e){ alert('Ошибка: '+e.message); }
                  }}
                  style={{padding:'8px 12px', borderRadius:8, border:'1px solid rgba(67,233,123,0.35)', background:'rgba(67,233,123,0.12)', color:'#b2ffb2', cursor:'pointer'}}
                >Применить сейчас</button>
              </div>
              <div style={{display:'flex', gap:10, marginTop:16, justifyContent:'space-between'}}>
                <div style={{display:'flex', gap:8}}>
                  {editRow.enabled ? (
                    <button onClick={async ()=>{ try { const t = localStorage.getItem('token'); const resp = await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}/disable`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${t}` } }); const data = await resp.json().catch(()=>({})); if (!resp.ok) throw new Error(data.error || data.stderr || 'Не удалось отключить'); alert('Пользователь отключен'); setEditRow({...editRow, enabled: false}); try { const r = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${t}` } }); const users = await r.json(); setAdminUsers(Array.isArray(users) ? users : []); } catch {} } catch(e){ alert('Ошибка: '+e.message); } }} style={{padding:'10px 14px', borderRadius:10, border:'1px solid rgba(239,68,68,0.35)', background:'rgba(239,68,68,0.15)', color:'#fecaca', cursor:'pointer'}}>Отключить</button>
                  ) : (
                    <button onClick={async ()=>{ try { const t = localStorage.getItem('token'); const resp = await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}/enable`, { method:'POST', headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${t}` }, body: JSON.stringify({ enabled: true }) }); const data = await resp.json().catch(()=>({})); if (!resp.ok) throw new Error(data.error || data.stderr || 'Не удалось включить'); alert('Пользователь включен'); setEditRow({...editRow, enabled: true}); } catch(e){ alert('Ошибка: '+e.message); } }} style={{padding:'10px 14px', borderRadius:10, border:'1px solid rgba(67,233,123,0.35)', background:'rgba(67,233,123,0.15)', color:'#b2ffb2', cursor:'pointer'}}>Включить</button>
                  )}
                  <button onClick={async ()=>{ if(window.confirm('Удалить пользователя? Это действие нельзя отменить.')){ try { const t = localStorage.getItem('token'); await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.name)}`, { method:'DELETE', headers:{ Authorization:`Bearer ${t}` } }); alert('Пользователь удален'); setEditRow(null); const r = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${t}` } }); const users = await r.json(); setAdminUsers(Array.isArray(users) ? users : []); } catch(e){ alert('Ошибка: '+e.message); } } }} style={{padding:'10px 14px', borderRadius:10, border:'1px solid rgba(239,68,68,0.45)', background:'rgba(239,68,68,0.18)', color:'#fecaca', cursor:'pointer'}}>Удалить</button>
                </div>
                <div style={{display:'flex', gap:10}}>
                  <button onClick={()=>setEditRow(null)} style={{padding:'10px 14px', borderRadius:10, border:'1px solid #374151', background:'#111827', color:'#e5e7eb', cursor:'pointer'}}>Отмена</button>
                <button onClick={async ()=>{
                  const token = localStorage.getItem('token');
                  try {
                    // Определяем актуальное имя пользователя (может измениться после переименования)
                    let currentUserName = editRow.name;
                    
                    // Если имя изменилось, сначала переименовываем
                    if (editRow.name && editRow.name !== (editRow.originalName || '')) {
                      const renameRes = await fetch(`/api/admin/local-users/${encodeURIComponent(editRow.originalName)}/rename`, { 
                        method:'POST', 
                        headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, 
                        body: JSON.stringify({ newName: editRow.name }) 
                      });
                      if (!renameRes.ok) {
                        const errorData = await renameRes.json().catch(() => ({ message: 'Ошибка переименования' }));
                        throw new Error(errorData.message || `Ошибка переименования: ${renameRes.status}`);
                      }
                      currentUserName = editRow.name;
                    }
                    
                    // Обновляем описание
                    const descRes = await fetch(`/api/admin/local-users/${encodeURIComponent(currentUserName)}/description`, { 
                      method:'POST', 
                      headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, 
                      body: JSON.stringify({ description: editRow.description || '' }) 
                    });
                    if (!descRes.ok) {
                      const errorData = await descRes.json().catch(() => ({ message: 'Ошибка обновления описания' }));
                      throw new Error(errorData.message || `Ошибка обновления описания: ${descRes.status}`);
                    }
                    
                    // Обновляем флаг no-expire
                    const noExpireRes = await fetch(`/api/admin/local-users/${encodeURIComponent(currentUserName)}/no-expire`, { 
                      method:'POST', 
                      headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, 
                      body: JSON.stringify({ noExpire: !!editRow.noExpire }) 
                    });
                    if (!noExpireRes.ok) {
                      const errorData = await noExpireRes.json().catch(() => ({ message: 'Ошибка обновления флага no-expire' }));
                      throw new Error(errorData.message || `Ошибка обновления флага no-expire: ${noExpireRes.status}`);
                    }
                    
                    // Обновляем пароль, если он указан
                    if ((editRow.password || '').trim().length > 0) {
                      const passwordRes = await fetch(`/api/admin/local-users/${encodeURIComponent(currentUserName)}/password`, { 
                        method:'POST', 
                        headers:{ 'Content-Type':'application/json', Authorization:`Bearer ${token}` }, 
                        body: JSON.stringify({ password: editRow.password.trim() }) 
                      });
                      if (!passwordRes.ok) {
                        const errorData = await passwordRes.json().catch(() => ({ error: 'Ошибка изменения пароля' }));
                        throw new Error(errorData.error || errorData.message || `Ошибка изменения пароля: ${passwordRes.status}`);
                      }
                    }
                    
                    // Обновляем список пользователей
                    const r = await fetch('/api/admin/local-users', { headers: { Authorization: `Bearer ${token}` } });
                    if (!r.ok) {
                      throw new Error(`Ошибка загрузки списка пользователей: ${r.status}`);
                    }
                    const users = await r.json();
                    setAdminUsers(Array.isArray(users) ? users : []);
                    setEditRow(null);
                    alert('Изменения сохранены успешно');
                  } catch (e) {
                    alert('Ошибка сохранения: ' + e.message);
                    console.error('Ошибка сохранения пользователя:', e);
                  }
                }} style={{padding:'10px 14px', borderRadius:10, border:'1px solid rgba(67,233,123,0.35)', background:'rgba(67,233,123,0.15)', color:'#b2ffb2', cursor:'pointer', fontWeight:700}}>Сохранить</button>
                </div>
              </div>
            </div>
          </div>
        ),
        !!editRow
      )}
      {createSafePortal(
        isMobile ? (
          <EmployeesMobile 
            key={`employees-mobile-${portalKey}`} 
            open={showEmployeesModal} 
            onClose={() => setShowEmployeesModal(false)} 
            onOpenMobileSidebar={onOpenMobileSidebar}
            onOpenUserRights={() => setShowUserRightsModal(true)}
          />
        ) : (
          <EmployeesListModal
            key={`employees-${portalKey}`}
            open={showEmployeesModal}
            onClose={() => setShowEmployeesModal(false)}
            isMobile={isMobile}
            onOpenUserRights={() => setShowUserRightsModal(true)}
          />
        ),
        showEmployeesModal
      )}
      {createSafePortal(
        isMobile ? (
          <CongratulationsMobile 
            key={`congratulations-mobile-${portalKey}`} 
            open={showBirthdaysModal} 
            onClose={() => setShowBirthdaysModal(false)} 
            onOpenMobileSidebar={onOpenMobileSidebar} 
          />
        ) : (
          <div
            style={{
              position:'fixed',
              top:0,
              left:'calc(380px + max((100vw - 380px - 1200px)/2, 0px))',
              width:'1170px',
              minWidth:'600px',
              maxWidth:'1170px',
              height:'92vh',
              margin:'32px 0',
              zIndex:100000,
              background:'transparent',
              display:'flex',
              alignItems:'center',
              justifyContent:'flex-start',
              pointerEvents:'auto'
            }}
            onClick={()=>setShowBirthdaysModal(false)}
          >
            <div style={{
              background:'linear-gradient(135deg, #232931 0%, #181c22 100%)',
              borderRadius:'28px',
              width:'100%',
              minWidth:'600px',
              maxWidth:'1200px',
              height:'100%',
              boxSizing:'border-box',
              boxShadow:'0 4px 32px rgba(0,0,0,0.15)',
              display:'flex',
              flexDirection:'column',
              position:'relative',
              color:'#fff',
              padding:'0',
              overflow:'hidden'
            }} onClick={e=>e.stopPropagation()}>
              <button
                onClick={()=>setShowBirthdaysModal(false)}
                style={{
                  position:'absolute',
                  top:16,
                  right:16,
                  fontSize:28,
                  background:'transparent',
                  border:'none',
                  cursor:'pointer',
                  color:'#fff',
                  fontWeight:'bold',
                  width:36,
                  height:36,
                  borderRadius:'50%',
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  transition:'background-color 0.3s, color 0.3s'
                }}
                onMouseEnter={e=>{ e.currentTarget.style.backgroundColor = 'rgba(34, 197, 94, 0.18)'; e.currentTarget.style.color = '#43e97b'; }}
                onMouseLeave={e=>{ e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#fff'; }}
                aria-label="Close modal"
              >
                ×
              </button>
              <div style={{width:'100%', height:'100%', background:'#fff', color:'#111', overflow:'auto'}}>
                <CongratulationsModal onClose={() => setShowBirthdaysModal(false)} />
              </div>
            </div>
          </div>
        ),
        showBirthdaysModal
      )}
      {createSafePortal(
        <EmojiSettingsModal 
          key={`emoji-settings-${portalKey}`} 
          open={showEmojiSettingsModal} 
          onClose={() => setShowEmojiSettingsModal(false)} 
        />,
        showEmojiSettingsModal
      )}
      {createSafePortal(
        <TemplatesManagementModal 
          key={`templates-${portalKey}`} 
          isOpen={showTemplatesModal} 
          onClose={() => setShowTemplatesModal(false)} 
        />,
        showTemplatesModal
      )}
      {createSafePortal(
        <AppTitleSettingsModal 
          key={`app-title-settings-${portalKey}`} 
          open={showAppTitleSettingsModal} 
          onClose={() => setShowAppTitleSettingsModal(false)} 
        />,
        showAppTitleSettingsModal
      )}
      {createSafePortal(
        <FrontendSettingsModal 
          key={`frontend-settings-${portalKey}`} 
          open={showFrontendSettingsModal} 
          onClose={() => setShowFrontendSettingsModal(false)} 
          isMobile={isMobile}
        />,
        showFrontendSettingsModal
      )}
      {createSafePortal(
        <PendingRegistrationsModal
          key={`pending-reg-${portalKey}`}
          open={showPendingRegModal}
          onClose={() => setShowPendingRegModal(false)}
          isMobile={isMobile}
          sidebarOffset={isMobile ? 0 : 320}
        />,
        showPendingRegModal
      )}
      {showOnecMassShutdownUserRights && (
        <OnecMassShutdownScheduleModal
          open={showOnecMassShutdownUserRights}
          onClose={() => setShowOnecMassShutdownUserRights(false)}
          isMobile={isMobile}
          sidebarOffset={isMobile ? 0 : 320}
        />
      )}
      {/* {showChatsModal && ReactDOM.createPortal(
        <div
          style={{
            position:'fixed',
            top:0,
            right:0,
            bottom:0,
            left:'320px',
            zIndex:99999,
            background:'transparent',
            display:'flex',
            justifyContent:'flex-end',
            alignItems:'center'
          }}
          onClick={()=>setShowChatsModal(false)}
        >
          <div style={{
            width:'100%',
            maxWidth:'600px',
            minWidth:'380px',
            height:'90%',
            background:'linear-gradient(135deg, #232931 0%, #181c22 100%)',
            borderRadius:'28px 0 0 28px',
            padding:'40px 48px',
            boxSizing:'border-box',
            overflowY:'auto',
            position:'relative',
            boxShadow:'-8px 0 40px #2193b044, 0 4px 32px rgba(0,0,0,0.15)',
            border:'none',
            animation:'modalFadeIn .35s cubic-bezier(.4,0,.2,1)',
            color:'#fff'
          }} onClick={e=>e.stopPropagation()}>
            <button
              onClick={()=>setShowChatsModal(false)}
              style={{
                position:'absolute',
                top:16,
                right:16,
                fontSize:28,
                background:'transparent',
                border:'none',
                cursor:'pointer',
                color:'#fff',
                fontWeight:'bold',
                width:36,
                height:36,
                borderRadius:'50%',
                display:'flex',
                alignItems:'center',
                justifyContent:'center',
                transition:'background-color 0.3s, color 0.3s'
              }}
              onMouseEnter={e=>{ e.currentTarget.style.backgroundColor = 'rgba(34, 197, 94, 0.18)'; e.currentTarget.style.color = '#43e97b'; }}
              onMouseLeave={e=>{ e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#fff'; }}
              aria-label="Close modal"
            >
              ×
            </button>
            <h2 style={{
              marginTop:0,
              marginBottom:18,
              color:'#43e97b',
              fontWeight:900,
              fontSize:'2em',
              letterSpacing:'0.5px',
              textShadow:'0 0 22px #43e97b, 0 0 32px #43e97b44, 0 0 2px #fff, 0 0 24px #43e97b88'
            }}>Ваши чаты</h2>
            <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:16 }}>
              <button
                onClick={() => {
                  dispatch({ type: 'TOGGLE_MODAL', payload: { modal: 'createChat', show: true } });
                  // при необходимости можно закрыть список чатов:
                  // setShowChatsModal(false);
                }}
                style={{
                  display:'inline-flex',
                  alignItems:'center',
                  gap:8,
                  padding:'10px 14px',
                  borderRadius:10,
                  border:'1px solid rgba(67,233,123,0.35)',
                  background:'rgba(67,233,123,0.15)',
                  color:'#b2ffb2',
                  cursor:'pointer'
                }}
                title="Создать чат"
              >
                <FiPlus size={18} /> Создать чат
              </button>
            </div>
            <ChatList setShowChatsModal={setShowChatsModal} />
          </div>
        </div>,
        document.body
      )} */}
    </>
  );
}